export const rememberWordData = [
  {
    length: '3',
    areacode: '011',
    city: '札幌',
    word: 'いい恋人は札幌市',
    keywordNumber: 'いい',
    rememberNumber: '11',
    keywordCity: 'いい恋人',
    rememberCity: '札幌',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '※白い恋人：札幌名物のお菓子',
  },
  {
    length: '4',
    areacode: '011x',
    city: '札幌',
    word: 'さっさと別れてきた広島',
    keywordNumber: '',
    rememberNumber: '',
    keywordCity: 'さっさ、別、きたひろしま',
    rememberCity: '札幌、江別、北広島',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '012',
    city: '千歳',
    word: 'いつ食べるもの？千歳飴',
    keywordNumber: 'いつ',
    rememberNumber: '12',
    keywordCity: '千歳',
    rememberCity: '千歳',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0123',
    city: '千歳',
    word: '1・2・3で飛び立て！新千歳空港',
    keywordNumber: '１・２・３',
    rememberNumber: '',
    keywordCity: '新千歳空港',
    rememberCity: '千歳',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '※新千歳空港：北海道の空の玄関口',
  },
  {
    length: '4',
    areacode: '0124',
    city: '芦別',
    word: 'にしべつあしべつ',
    keywordNumber: 'にし',
    rememberNumber: '24',
    keywordCity: 'あしべつ',
    rememberCity: '芦別',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0125',
    city: '滝川',
    word: 'ニコニコタッキーカワイイネ',
    keywordNumber: 'ニコニコ',
    rememberNumber: '25',
    keywordCity: 'タッキーカワ',
    rememberCity: '滝川',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0126',
    city: '岩見沢',
    word: '岩風呂岩見沢',
    keywordNumber: '風呂',
    rememberNumber: '26',
    keywordCity: '岩見沢',
    rememberCity: '岩見沢',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '013',
    city: '函館',
    word: '函館の遺産は縄文遺跡群',
    keywordNumber: '遺産',
    rememberNumber: '13',
    keywordCity: '縄文遺跡群',
    rememberCity: '函館',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '※垣ノ島遺跡と大船遺跡が登録されている',
  },
  {
    length: '4',
    areacode: '0133',
    city: '石狩',
    word: 'さざれ石借りてくよ',
    keywordNumber: 'さざ',
    rememberNumber: '33',
    keywordCity: '石借り',
    rememberCity: '石狩',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0134',
    city: '小樽',
    word: '刺身の小樽',
    keywordNumber: '刺',
    rememberNumber: '34',
    keywordCity: '刺身',
    rememberCity: '小樽',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '※刺身：市場の新鮮な魚介が有名',
  },
  {
    length: '4',
    areacode: '0135',
    city: '余市',
    word: 'いざこざ起こるよ余り1',
    keywordNumber: 'いざこ',
    rememberNumber: '135',
    keywordCity: '余り1',
    rememberCity: '余市',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0136',
    city: 'ニセコ',
    word: 'さむいニセコのスキー場',
    keywordNumber: 'さむ',
    rememberNumber: '36',
    keywordCity: 'スキー場',
    rememberCity: 'ニセコ',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '※スキー場：ニセコアンヌプリが有名',
  },
  {
    length: '4',
    areacode: '0137',
    city: '森',
    word: 'みんなの森',
    keywordNumber: 'みんな',
    rememberNumber: '37',
    keywordCity: '森',
    rememberCity: '森',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0138',
    city: '函館',
    word: '(世界)遺産はまだだよ五稜郭',
    keywordNumber: '遺産は',
    rememberNumber: '138',
    keywordCity: '五稜郭',
    rememberCity: '函館',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '※「五稜郭と箱館戦争の遺構」で北海道遺産ではある',
  },
  {
    length: '4',
    areacode: '0139',
    city: '松前',
    word: 'サンキューを待つ前に',
    keywordNumber: 'サンキュー',
    rememberNumber: '39',
    keywordCity: '待つ前に',
    rememberCity: '松前',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '014',
    city: '室蘭',
    word: '美味しい～！室蘭カレーラーメン',
    keywordNumber: '美味し',
    rememberNumber: '014',
    keywordCity: '室蘭カレーラーメン',
    rememberCity: '室蘭',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0142',
    city: '伊達',
    word: '異質な伊達者',
    keywordNumber: '異質',
    rememberNumber: '142',
    keywordCity: '伊達',
    rememberCity: '伊達',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0143',
    city: '室蘭',
    word: 'カレーラーメンの美味しさ',
    keywordNumber: '美味しさ',
    rememberNumber: '0143',
    keywordCity: 'カレーラーメン',
    rememberCity: '室蘭',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '※カレーラーメン：室蘭名物のラーメン',
  },
  {
    length: '4',
    areacode: '0144',
    city: '苫小牧',
    word: '獅子舞苫小牧',
    keywordNumber: '獅子',
    rememberNumber: '44',
    keywordCity: '苫小牧',
    rememberCity: '苫小牧',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '※駒大苫小牧のリズムで',
  },
  {
    length: '4',
    areacode: '0145',
    city: '日高',
    word: '横に日高昆布',
    keywordNumber: '横',
    rememberNumber: '45',
    keywordCity: '日高昆布',
    rememberCity: '日高',
    dateAisu: '11/26',
    dateTorme: '',
    supplement: '※日高昆布：日高の名産品',
  },
  {
    length: '4',
    areacode: '0146',
    city: '浦河',
    word: '白い襟の裏側は',
    keywordNumber: '白',
    rememberNumber: '46',
    keywordCity: '襟の、裏側',
    rememberCity: 'えりも、浦河',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '015',
    city: '帯広',
    word: '試されに行こう道東へ',
    keywordNumber: '行こ',
    rememberNumber: '15',
    keywordCity: '道東',
    rememberCity: '道東',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0152',
    city: '網走',
    word: 'ゴツい刑務所網走監獄',
    keywordNumber: 'ゴツ',
    rememberNumber: '52',
    keywordCity: '網走監獄',
    rememberCity: '網走',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '※網走監獄：明治期の刑務所',
  },
  {
    length: '4',
    areacode: '0153',
    city: '根室',
    word: '根菜根室',
    keywordNumber: '根菜',
    rememberNumber: '53',
    keywordCity: '根室',
    rememberCity: '根室',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0154',
    city: '釧路',
    word: 'こしろくしろ',
    keywordNumber: 'こし',
    rememberNumber: '54',
    keywordCity: 'くしろ',
    rememberCity: '釧路',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0155',
    city: '帯広',
    word: 'ゴーゴー帯広ばんえい競馬',
    keywordNumber: 'ゴーゴー',
    rememberNumber: '55',
    keywordCity: '帯広ばんえい競馬',
    rememberCity: '帯広',
    dateAisu: '11/21',
    dateTorme: '',
    supplement: '※ばんえい競馬：馬がそりを引くタイプの競馬',
  },
  {
    length: '4',
    areacode: '0156',
    city: '本別',
    word: 'コロコロコミック別冊',
    keywordNumber: 'コロコロ',
    rememberNumber: '56',
    keywordCity: 'コミック別',
    rememberCity: '本別',
    dateAisu: '11/25',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0157',
    city: '北見',
    word: '小麦の粉は北見産',
    keywordNumber: '粉',
    rememberNumber: '57',
    keywordCity: '小麦',
    rememberCity: '北見',
    dateAisu: '11/25',
    dateTorme: '',
    supplement: '※小麦：菓子用薄力小麦「北見95号」が有名',
  },
  {
    length: '4',
    areacode: '0158',
    city: '紋別',
    word: 'ゴーヤの紋章',
    keywordNumber: 'ゴーヤ',
    rememberNumber: '58',
    keywordCity: '紋',
    rememberCity: '紋別',
    dateAisu: '11/25',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '016',
    city: '旭川',
    word: '以北の果ては道北です',
    keywordNumber: '以北',
    rememberNumber: '16',
    keywordCity: '道北',
    rememberCity: '道北',
    dateAisu: '11/25',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0162',
    city: '稚内',
    word: '唯一無二もわっかんない',
    keywordNumber: '一無二',
    rememberNumber: '162',
    keywordCity: 'わっかんない',
    rememberCity: '稚内',
    dateAisu: '11/25',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0163',
    city: '天塩',
    word: '霧散霧塩',
    keywordNumber: '霧散',
    rememberNumber: '63',
    keywordCity: '塩',
    rememberCity: '天塩',
    dateAisu: '11/25',
    dateTorme: '',
    supplement: '※霧散霧消',
  },
  {
    length: '4',
    areacode: '0164',
    city: '留萌',
    word: '虫に萌え',
    keywordNumber: '虫',
    rememberNumber: '64',
    keywordCity: '萌え',
    rememberCity: '留萌',
    dateAisu: '11/25',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0165',
    city: '名寄',
    word: '別なよろこび',
    keywordNumber: 'ろこ',
    rememberNumber: '65',
    keywordCity: '別、なよろ',
    rememberCity: '士別、名寄',
    dateAisu: '11/25',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0166',
    city: '旭川',
    word: 'ろくろ首みたいキリンさん',
    keywordNumber: 'ろくろ首',
    rememberNumber: '66',
    keywordCity: 'キリンさん',
    rememberCity: '旭川',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '※キリンさん：旭山動物園のアミメキリン',
  },
  {
    length: '4',
    areacode: '0167',
    city: '富良野',
    word: 'いろんな種類のラベンダー',
    keywordNumber: 'いろんな',
    rememberNumber: '167',
    keywordCity: 'ラベンダー',
    rememberCity: '富良野',
    dateAisu: '11/25',
    dateTorme: '',
    supplement: '※ラベンダー：富良野の名産品',
  },
  {
    length: '3',
    areacode: '017',
    city: '青森',
    word: '青の稲妻 青森県',
    keywordNumber: '稲',
    rememberNumber: '17',
    keywordCity: '青',
    rememberCity: '青森',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '※稲妻：「青天の霹靂」が青森のブランド米',
  },
  {
    length: '4',
    areacode: '0172',
    city: '弘前',
    word: '夏前',
    keywordNumber: '夏',
    rememberNumber: '72',
    keywordCity: '前',
    rememberCity: '弘前',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '※0272：前橋と同じ覚え方',
  },
  {
    length: '4',
    areacode: '0173',
    city: '五所川原',
    word: '波に乗れ揚げ鯛焼き',
    keywordNumber: '波',
    rememberNumber: '73',
    keywordCity: '揚げ鯛焼き',
    rememberCity: '五所川原',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '※揚げ鯛焼き(あげたい)：五所川原名物、桃鉄でも有名',
  },
  {
    length: '4',
    areacode: '0174',
    city: '今別',
    word: '梨と今別れよう',
    keywordNumber: '梨',
    rememberNumber: '74',
    keywordCity: '今別',
    rememberCity: '今別',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0175',
    city: 'むつ',
    word: 'なごむつ',
    keywordNumber: 'なご',
    rememberNumber: '75',
    keywordCity: 'むつ',
    rememberCity: '陸奥',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '※和む',
  },
  {
    length: '4',
    areacode: '0176',
    city: '十和田',
    word: '南無は永遠だ',
    keywordNumber: '南無',
    rememberNumber: '76',
    keywordCity: '永遠だ',
    rememberCity: '十和田',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0177',
    city: '青森',
    word: '旧暦の7月7日はねぶた祭',
    keywordNumber: '七月七日',
    rememberNumber: '77',
    keywordCity: 'ねぶた祭',
    rememberCity: '青森',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '※ねぶた祭：東北三大祭り',
  },
  {
    length: '4',
    areacode: '0178',
    city: '八戸',
    word: '八戸',
    keywordNumber: '八',
    rememberNumber: '8',
    keywordCity: '八戸',
    rememberCity: '八戸',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0179',
    city: '三戸',
    word: '泣くほどうまいニンニクサンド',
    keywordNumber: '泣く',
    rememberNumber: '79',
    keywordCity: 'ニンニク、サンド',
    rememberCity: '田子、三戸',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '※ニンニク：田子の名産品',
  },
  {
    length: '3',
    areacode: '018',
    city: '秋田',
    word: '18歳の秋田美人',
    keywordNumber: '18',
    rememberNumber: '18',
    keywordCity: '秋田美人',
    rememberCity: '秋田',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '※秋田美人：日本三大美人',
  },
  {
    length: '4',
    areacode: '0182',
    city: '横手',
    word: 'パンツ横縞',
    keywordNumber: 'パンツ',
    rememberNumber: '82',
    keywordCity: '横',
    rememberCity: '横手',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0183',
    city: '湯沢',
    word: '婆さんの湯',
    keywordNumber: '婆さん',
    rememberNumber: '83',
    keywordCity: '湯',
    rememberCity: '湯沢',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0184',
    city: '由利本荘',
    word: 'いやよユリに過保護',
    keywordNumber: 'いやよ',
    rememberNumber: '184',
    keywordCity: 'ユリ、に過保',
    rememberCity: '由利本荘、にかほ',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0185',
    city: '男鹿',
    word: '箱入りナマハゲ',
    keywordNumber: '箱',
    rememberNumber: '85',
    keywordCity: 'ナマハゲ',
    rememberCity: '男鹿',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '※ナマハゲ：男鹿半島の来訪神',
  },
  {
    length: '4',
    areacode: '0186',
    city: '大館',
    word: 'ハムもおだてりゃ木に登る',
    keywordNumber: 'ハム',
    rememberNumber: '86',
    keywordCity: 'おだて',
    rememberCity: '大館',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '※豚もおだてりゃ木に登る',
  },
  {
    length: '4',
    areacode: '0187',
    city: '仙北',
    word: '戦国の華、大戦',
    keywordNumber: '華',
    rememberNumber: '87',
    keywordCity: '戦国、大戦',
    rememberCity: '仙北、大仙',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0188',
    city: '秋田',
    word: 'はっぱの秋だ',
    keywordNumber: 'はっぱ',
    rememberNumber: '88',
    keywordCity: '秋だ',
    rememberCity: '秋田',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '019',
    city: '岩手',
    word: '岩で行くで！',
    keywordNumber: '行く',
    rememberNumber: '19',
    keywordCity: '岩で',
    rememberCity: '岩手',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0191',
    city: '一関',
    word: '一関',
    keywordNumber: '一',
    rememberNumber: '1',
    keywordCity: '一関',
    rememberCity: '一関',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0192',
    city: '大船渡',
    word: '国々を渡る大船と',
    keywordNumber: '国々',
    rememberNumber: '92',
    keywordCity: '大船',
    rememberCity: '大船',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0193',
    city: '釜石',
    word: '草の釜揚げ',
    keywordNumber: '草',
    rememberNumber: '93',
    keywordCity: '釜',
    rememberCity: '釜石',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0194',
    city: '久慈',
    word: '久慈',
    keywordNumber: '久慈',
    rememberNumber: '94',
    keywordCity: '久慈',
    rememberCity: '久慈',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0195',
    city: '二戸',
    word: '救護だニトログリセリン',
    keywordNumber: '救護',
    rememberNumber: '95',
    keywordCity: 'ニト',
    rememberCity: '二戸',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '※ニトログリセリン：心臓発作に有効な薬',
  },
  {
    length: '4',
    areacode: '0196',
    city: '盛岡',
    word: '黒い森',
    keywordNumber: '黒',
    rememberNumber: '96',
    keywordCity: '森',
    rememberCity: '盛岡',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '※ドイツにある森',
  },
  {
    length: '4',
    areacode: '0197',
    city: '北上',
    word: '北には行くな',
    keywordNumber: '行くな',
    rememberNumber: '197',
    keywordCity: '北',
    rememberCity: '北上',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0198',
    city: '花巻',
    word: 'くっぱまき',
    keywordNumber: 'くっぱ',
    rememberNumber: '98',
    keywordCity: 'ぱまき',
    rememberCity: '花巻',
    dateAisu: '11/27',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '022',
    city: '宮城',
    word: 'ずんだもち宮城県',
    keywordNumber: 'ず',
    rememberNumber: '2',
    keywordCity: 'ずんだ',
    rememberCity: '宮城',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '※ずんだ：宮城名物の枝豆由来の餡',
  },
  {
    length: '4',
    areacode: '0220',
    city: '登米',
    word: '二重に留め具で挟む',
    keywordNumber: '二重',
    rememberNumber: '20',
    keywordCity: '留め、挟む',
    rememberCity: '登米、迫',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '※迫町：合併前の自治体名',
  },
  {
    length: '4',
    areacode: '0222',
    city: '仙台',
    word: 'ずずずんだ',
    keywordNumber: 'ずずず',
    rememberNumber: '222',
    keywordCity: 'ずんだ',
    rememberCity: '仙台',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0223',
    city: '岩沼',
    word: '兄さん何も言わぬまま',
    keywordNumber: '兄さん',
    rememberNumber: '23',
    keywordCity: '言わぬま',
    rememberCity: '岩沼',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0224',
    city: '白石',
    word: '白石',
    keywordNumber: '白',
    rememberNumber: '4',
    keywordCity: '白石',
    rememberCity: '白石',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0225',
    city: '石巻',
    word: 'ニコイチの巻',
    keywordNumber: 'ニコ',
    rememberNumber: '25',
    keywordCity: 'イチの巻',
    rememberCity: '石巻',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0226',
    city: '気仙沼',
    word: '風呂の換気扇',
    keywordNumber: '風呂',
    rememberNumber: '26',
    keywordCity: '気扇',
    rememberCity: '気仙沼',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0227',
    city: '仙台',
    word: '通なずんだ',
    keywordNumber: '通な',
    rememberNumber: '27',
    keywordCity: 'ずんだ',
    rememberCity: '仙台',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0228',
    city: '栗原',
    word: 'つやつやの栗だって',
    keywordNumber: 'つやつや',
    rememberNumber: '28',
    keywordCity: '栗、だって',
    rememberCity: '栗原、築館',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '※築館町：合併前の自治体名',
  },
  {
    length: '4',
    areacode: '0229',
    city: '大崎',
    word: '古い肉の多さ',
    keywordNumber: '肉',
    rememberNumber: '29',
    keywordCity: '多さ、古い',
    rememberCity: '大崎、古川',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '※古川市：合併前の自治体名',
  },
  {
    length: '3',
    areacode: '023',
    city: '山形',
    word: 'さくらんぼの山形県',
    keywordNumber: 'さ',
    rememberNumber: '023',
    keywordCity: 'さくらんぼ',
    rememberCity: '山形',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '※さくらんぼ：山形の名産品',
  },
  {
    length: '4',
    areacode: '0233',
    city: '新庄',
    word: '新庄三球三振',
    keywordNumber: '三 三',
    rememberNumber: '33',
    keywordCity: '新庄',
    rememberCity: '新庄',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '※新庄：新庄剛志(元プロ野球選手)',
  },
  {
    length: '4',
    areacode: '0234',
    city: '酒田',
    word: '刺身とお酒',
    keywordNumber: '刺身',
    rememberNumber: '34',
    keywordCity: '酒',
    rememberCity: '酒田',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0235',
    city: '鶴岡',
    word: '亀から見たら 鶴はザコ',
    keywordNumber: 'ザコ',
    rememberNumber: '35',
    keywordCity: '鶴',
    rememberCity: '鶴岡',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '※鶴は千年、亀は万年',
  },
  {
    length: '4',
    areacode: '0236',
    city: '山形',
    word: '寒い日は芋煮',
    keywordNumber: '寒',
    rememberNumber: '36',
    keywordCity: '芋煮',
    rememberCity: '山形',
    dateAisu: '',
    dateTorme: '',
    supplement: '※芋煮：山形の郷土料理',
  },
  {
    length: '4',
    areacode: '0237',
    city: '村山',
    word: 'みんなの村',
    keywordNumber: 'みんな',
    rememberNumber: '37',
    keywordCity: '村',
    rememberCity: '村山',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0238',
    city: '米沢',
    word: '米沢牛を捌く',
    keywordNumber: '捌',
    rememberNumber: '38',
    keywordCity: '米沢',
    rememberCity: '米沢',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '※米沢牛：日本三大和牛',
  },
  {
    length: '3',
    areacode: '024',
    city: '福島',
    word: 'ふーしま県',
    keywordNumber: 'ふーし',
    rememberNumber: '24',
    keywordCity: 'ふーしま',
    rememberCity: '福島',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0240',
    city: '大熊',
    word: '夜空のおおぐま座',
    keywordNumber: '夜空',
    rememberNumber: '40',
    keywordCity: 'おおぐま',
    rememberCity: '大熊',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0241',
    city: '喜多方',
    word: 'お寿司行きたかった',
    keywordNumber: 'お寿司行',
    rememberNumber: '0241',
    keywordCity: 'きたかった',
    rememberCity: '喜多方',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0242',
    city: '会津若松',
    word: '西に進めばあいつが待つ',
    keywordNumber: '西に',
    rememberNumber: '242',
    keywordCity: 'あいつ若',
    rememberCity: '会津若松',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0243',
    city: '二本松',
    word: '4・3・二本松',
    keywordNumber: '4・3',
    rememberNumber: '43',
    keywordCity: '二本松',
    rememberCity: '二本松',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0244',
    city: '相馬',
    word: 'シシュウマイ',
    keywordNumber: 'シシュ',
    rememberNumber: '44',
    keywordCity: 'ウマ',
    rememberCity: '相馬',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0245',
    city: '福島',
    word: '横縞服の縞',
    keywordNumber: '横',
    rememberNumber: '45',
    keywordCity: '服の縞',
    rememberCity: '福島',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0246',
    city: 'いわき',
    word: '磐城',
    keywordNumber: '城',
    rememberNumber: '46',
    keywordCity: '磐城',
    rememberCity: '磐城',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0247',
    city: '田村',
    word: 'シナムラ',
    keywordNumber: 'シナ',
    rememberNumber: '47',
    keywordCity: 'ムラ',
    rememberCity: '田村',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '※しまむら、しながわ：0947 田川',
  },
  {
    length: '4',
    areacode: '0248',
    city: '白河',
    word: 'シワカワ',
    keywordNumber: 'シワ',
    rememberNumber: '48',
    keywordCity: 'シワカワ',
    rememberCity: '白河',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0249',
    city: '郡山',
    word: '強く肯定',
    keywordNumber: '強く',
    rememberNumber: '249',
    keywordCity: '肯',
    rememberCity: '郡山',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '025',
    city: '新潟',
    word: 'にいごた県',
    keywordNumber: 'にいご',
    rememberNumber: '25',
    keywordCity: 'にいごた',
    rememberCity: '新潟',
    dateAisu: '11/28',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0250',
    city: '五泉',
    word: '五千',
    keywordNumber: '五千',
    rememberNumber: '50',
    keywordCity: '五千',
    rememberCity: '五泉',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0252',
    city: '新潟',
    word: '新潟',
    keywordNumber: '新',
    rememberNumber: '2',
    keywordCity: '新潟',
    rememberCity: '新潟',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0253',
    city: '新潟',
    word: '-',
    keywordNumber: '-',
    rememberNumber: '-',
    keywordCity: '-',
    rememberCity: '-',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0254',
    city: '新発田',
    word: '新発田',
    keywordNumber: '新',
    rememberNumber: '4',
    keywordCity: '新発田',
    rememberCity: '新発田',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0255',
    city: '上越',
    word: 'ここを越えていけ',
    keywordNumber: 'ここ',
    rememberNumber: '55',
    keywordCity: '越',
    rememberCity: '上越',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0256',
    city: '三条',
    word: 'ゴロツキ参上！',
    keywordNumber: 'ゴロ',
    rememberNumber: '56',
    keywordCity: '参上',
    rememberCity: '三条',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0257',
    city: '柏崎',
    word: 'お菓子コーナー',
    keywordNumber: 'コーナー',
    rememberNumber: '57',
    keywordCity: '菓子',
    rememberCity: '柏崎',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0258',
    city: '長岡',
    word: '今夜は長いよ',
    keywordNumber: '今夜',
    rememberNumber: '58',
    keywordCity: '長',
    rememberCity: '長岡',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '※0958長崎と同じ覚え方',
  },
  {
    length: '4',
    areacode: '0259',
    city: '佐渡',
    word: '時刻はトキ',
    keywordNumber: '刻',
    rememberNumber: '59',
    keywordCity: 'トキ',
    rememberCity: '佐渡',
    dateAisu: '12/03',
    dateTorme: '',
    supplement: '※トキ：佐渡で保護飼育されている',
  },
  {
    length: '3',
    areacode: '026',
    city: '長野',
    word: 'お風呂が長いの 長野県',
    keywordNumber: 'お風呂',
    rememberNumber: '026',
    keywordCity: '長いの',
    rememberCity: '長野',
    dateAisu: '12/05',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0260',
    city: '阿南',
    word: '群れたアナコンダ',
    keywordNumber: '群れ',
    rememberNumber: '60',
    keywordCity: 'アナ',
    rememberCity: '阿南',
    dateAisu: '12/05',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0261',
    city: '大町',
    word: 'ロイヤルマッチ',
    keywordNumber: 'ロイ',
    rememberNumber: '61',
    keywordCity: 'マッチ',
    rememberCity: '大町',
    dateAisu: '12/05',
    dateTorme: '',
    supplement: '※スマホアプリの名前',
  },
  {
    length: '4',
    areacode: '0262',
    city: '長野',
    word: 'お風呂に蛾なの！',
    keywordNumber: 'お風呂に',
    rememberNumber: '0262',
    keywordCity: '蛾なの',
    rememberCity: '長野',
    dateAisu: '12/05',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0263',
    city: '松本',
    word: '無惨な松',
    keywordNumber: '無残',
    rememberNumber: '63',
    keywordCity: '松',
    rememberCity: '松本',
    dateAisu: '12/05',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0264',
    city: '木曽',
    word: '虫の木そっと',
    keywordNumber: '虫',
    rememberNumber: '64',
    keywordCity: '木そ',
    rememberCity: '木曽',
    dateAisu: '12/05',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0265',
    city: '飯田',
    word: 'むごいいだ',
    keywordNumber: 'むご',
    rememberNumber: '65',
    keywordCity: 'いいだ',
    rememberCity: '飯田',
    dateAisu: '12/05',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0266',
    city: '諏訪',
    word: 'モクモク 諏訪の工業地帯',
    keywordNumber: 'モクモク',
    rememberNumber: '66',
    keywordCity: '諏訪',
    rememberCity: '諏訪',
    dateAisu: '12/05',
    dateTorme: '',
    supplement: '※諏訪工業地帯：時計などの精密機械工業が有名',
  },
  {
    length: '4',
    areacode: '0267',
    city: '小諸',
    word: '胸毛オモロ',
    keywordNumber: '胸',
    rememberNumber: '67',
    keywordCity: 'オモロ',
    rememberCity: '小諸',
    dateAisu: '12/06',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0268',
    city: '上田',
    word: '牢屋は上だ',
    keywordNumber: '牢屋',
    rememberNumber: '68',
    keywordCity: '上だ',
    rememberCity: '上田',
    dateAisu: '12/05',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0269',
    city: '飯山',
    word: 'ロックがいい山',
    keywordNumber: 'ロック',
    rememberNumber: '69',
    keywordCity: 'マウンテン',
    rememberCity: '飯山',
    dateAisu: '12/06',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '027',
    city: '群馬',
    word: 'ツナ軍艦の 群馬県',
    keywordNumber: 'ツナ',
    rememberNumber: '27',
    keywordCity: '軍艦',
    rememberCity: '群馬',
    dateAisu: '12/06',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0270',
    city: '伊勢崎',
    word: '伊勢海老になれー',
    keywordNumber: 'なれ',
    rememberNumber: '70',
    keywordCity: '伊勢',
    rememberCity: '伊勢崎',
    dateAisu: '12/06',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0272',
    city: '前橋',
    word: '夏前',
    keywordNumber: '夏',
    rememberNumber: '72',
    keywordCity: '前',
    rememberCity: '前橋',
    dateAisu: '12/06',
    dateTorme: '',
    supplement: '※0172弘前と同じ覚え方',
  },
  {
    length: '4',
    areacode: '0273',
    city: '高崎',
    word: '高菜さん',
    keywordNumber: '菜さん',
    rememberNumber: '73',
    keywordCity: '高',
    rememberCity: '高崎',
    dateAisu: '12/06',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0274',
    city: '富岡',
    word: '富岡製糸場',
    keywordNumber: '糸',
    rememberNumber: '4',
    keywordCity: '富岡',
    rememberCity: '富岡',
    dateAisu: '12/06',
    dateTorme: '',
    supplement: '※富岡製糸場：明治期の官営工場',
  },
  {
    length: '4',
    areacode: '0276',
    city: '太田',
    word: '南無お陀仏',
    keywordNumber: '南無',
    rememberNumber: '76',
    keywordCity: 'お陀',
    rememberCity: '太田',
    dateAisu: '12/06',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0277',
    city: '桐生',
    word: 'ラッキリューセブン',
    keywordNumber: 'セブン',
    rememberNumber: '7',
    keywordCity: 'キリュー',
    rememberCity: '桐生',
    dateAisu: '12/06',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0278',
    city: '沼田',
    word: '沼で難破',
    keywordNumber: '難破',
    rememberNumber: '78',
    keywordCity: '沼で',
    rememberCity: '沼田',
    dateAisu: '12/06',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0279',
    city: '渋川',
    word: '泣く泣く渋柿',
    keywordNumber: '泣く泣く',
    rememberNumber: '79',
    keywordCity: '渋柿',
    rememberCity: '渋川',
    dateAisu: '12/06',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '028',
    city: '栃木',
    word: 'ツヤツヤとちおとめ',
    keywordNumber: 'ツヤツヤ',
    rememberNumber: '28',
    keywordCity: 'とちおとめ',
    rememberCity: '栃木',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '※とちおとめ：栃木発のいちごの品種',
  },
  {
    length: '4',
    areacode: '0280',
    city: '古河',
    word: 'あの子がパレード',
    keywordNumber: 'パレ',
    rememberNumber: '80',
    keywordCity: '子が',
    rememberCity: '古河',
    dateAisu: '12/07',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0281',
    city: '鉾田',
    word: 'パイを誇った',
    keywordNumber: 'パイ',
    rememberNumber: '81',
    keywordCity: '誇った',
    rememberCity: '鉾田',
    dateAisu: '12/07',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0282',
    city: '栃木',
    word: 'とちおとめパンツ',
    keywordNumber: 'パンツ',
    rememberNumber: '82',
    keywordCity: 'とちおとめ',
    rememberCity: '栃木',
    dateAisu: '12/07',
    dateTorme: '',
    supplement: '※いちごパンツ',
  },
  {
    length: '4',
    areacode: '0283',
    city: '佐野',
    word: '佐野',
    keywordNumber: '佐',
    rememberNumber: '3',
    keywordCity: '佐野',
    rememberCity: '佐野',
    dateAisu: '12/07',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0284',
    city: '足利',
    word: 'パシリの足',
    keywordNumber: 'パシ',
    rememberNumber: '84',
    keywordCity: '足',
    rememberCity: '足利',
    dateAisu: '12/07',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0285',
    city: '小山',
    word: '箱の山',
    keywordNumber: '箱',
    rememberNumber: '85',
    keywordCity: 'の山',
    rememberCity: '小山',
    dateAisu: '12/07',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0286',
    city: '宇都宮',
    word: 'ハロウツノミヤ',
    keywordNumber: 'ハロウ',
    rememberNumber: '86',
    keywordCity: 'ウツノミヤ',
    rememberCity: '宇都宮',
    dateAisu: '12/07',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0287',
    city: '那須塩原',
    word: 'バナナナス',
    keywordNumber: 'バナナ',
    rememberNumber: '87',
    keywordCity: 'ナス',
    rememberCity: '那須塩原',
    dateAisu: '12/07',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0288',
    city: '日光',
    word: 'パパもニッコリ',
    keywordNumber: 'パパ',
    rememberNumber: '88',
    keywordCity: 'ニッコリ',
    rememberCity: '日光',
    dateAisu: '12/07',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0289',
    city: '鹿沼',
    word: '野球馬鹿の沼',
    keywordNumber: '野球',
    rememberNumber: '89',
    keywordCity: '鹿の沼',
    rememberCity: '鹿沼',
    dateAisu: '12/07',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '029',
    city: '茨城',
    word: '畑のお肉 水戸納豆',
    keywordNumber: 'お肉',
    rememberNumber: '029',
    keywordCity: '水戸納豆',
    rememberCity: '茨城',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '※水戸納豆：水戸名物',
  },
  {
    length: '',
    areacode: '0291',
    city: '鉾田',
    word: '球威を誇った',
    keywordNumber: '球威',
    rememberNumber: '91',
    keywordCity: '誇った',
    rememberCity: '鉾田',
    dateAisu: '12/23',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0292',
    city: '水戸',
    word: '水戸光圀',
    keywordNumber: '圀',
    rememberNumber: '92',
    keywordCity: '水戸',
    rememberCity: '水戸',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '※水戸光圀：水戸黄門',
  },
  {
    length: '4',
    areacode: '0293',
    city: '高萩',
    word: '草が高すぎ',
    keywordNumber: '草',
    rememberNumber: '93',
    keywordCity: '高すぎ',
    rememberCity: '高萩',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0294',
    city: '常陸太田',
    word: 'つくし、太く立つ',
    keywordNumber: 'つくし',
    rememberNumber: '294',
    keywordCity: '太く、立つ',
    rememberCity: '常陸太田、日立',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0295',
    city: '常陸大宮',
    word: '求婚は大見え切って',
    keywordNumber: '求婚',
    rememberNumber: '95',
    keywordCity: '大見え',
    rememberCity: '大宮',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0296',
    city: '笠間',
    word: '黒い傘間に合ってます',
    keywordNumber: '黒い',
    rememberNumber: '96',
    keywordCity: '傘間',
    rememberCity: '笠間',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0297',
    city: '坂東',
    word: '苦難のバンド',
    keywordNumber: '苦難',
    rememberNumber: '97',
    keywordCity: 'バンド',
    rememberCity: '坂東',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0298',
    city: '土浦',
    word: 'つくば',
    keywordNumber: 'つくば',
    rememberNumber: '298',
    keywordCity: 'つくば',
    rememberCity: 'つくば',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '※ＭＡは土浦市だが「つくば」が綺麗すぎるので',
  },
  {
    length: '4',
    areacode: '0299',
    city: '鹿嶋',
    word: '救急箱貸します',
    keywordNumber: '救急',
    rememberNumber: '99',
    keywordCity: '貸しま',
    rememberCity: '鹿嶋',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '03 ',
    city: '東京',
    word: '東京03',
    keywordNumber: '03',
    rememberNumber: '03',
    keywordCity: '東京',
    rememberCity: '東京',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '※お笑い芸人のグループ名にもなっている',
  },
  {
    length: '4',
    areacode: '03xx',
    city: '狛江',
    word: '三コマ漫画',
    keywordNumber: '三',
    rememberNumber: '3',
    keywordCity: 'コマ',
    rememberCity: '狛江',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '042',
    city: '八王子',
    word: '四二が八王子',
    keywordNumber: '四二',
    rememberNumber: '42',
    keywordCity: '八王子',
    rememberCity: '八王子',
    dateAisu: '12/09',
    dateTorme: '',
    supplement: '※4×2=8',
  },
  {
    length: '4',
    areacode: '0420',
    city: '所沢',
    word: 'それがつれぇところだわ',
    keywordNumber: 'つれぇ',
    rememberNumber: '20',
    keywordCity: 'ところだわ',
    rememberCity: '所沢',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0422',
    city: '武蔵野',
    word: 'にんにん武者修行',
    keywordNumber: 'にんにん',
    rememberNumber: '22',
    keywordCity: '武者',
    rememberCity: '武蔵野',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0423',
    city: '国分寺',
    word: '兄さんが国を分ける',
    keywordNumber: '兄さん',
    rememberNumber: '23',
    keywordCity: '国を分ける',
    rememberCity: '国分寺',
    dateAisu: '12/09',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0424',
    city: '西東京',
    word: '西東京',
    keywordNumber: '西',
    rememberNumber: '24',
    keywordCity: '西東京',
    rememberCity: '西東京',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0425',
    city: '立川',
    word: '濁ったちいかわ',
    keywordNumber: '濁',
    rememberNumber: '25',
    keywordCity: 'たちいかわ',
    rememberCity: '立川',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '※ちいかわ：漫画のキャラクター',
  },
  {
    length: '4',
    areacode: '0426',
    city: '八王子',
    word: '２＋６＝八王子',
    keywordNumber: '２＋６',
    rememberNumber: '26',
    keywordCity: '八王子',
    rememberCity: '八王子',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0427',
    city: '相模原',
    word: '横綱相撲',
    keywordNumber: '綱',
    rememberNumber: '27',
    keywordCity: '相撲',
    rememberCity: '相模原',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0428',
    city: '青梅',
    word: 'つっぱい梅干し',
    keywordNumber: 'つっぱい',
    rememberNumber: '28',
    keywordCity: '梅',
    rememberCity: '青梅',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0429',
    city: '飯能',
    word: '肉と飯',
    keywordNumber: '肉',
    rememberNumber: '29',
    keywordCity: '飯',
    rememberCity: '飯能',
    dateAisu: '12/08',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '043',
    city: '千葉',
    word: '梨の産地だよ 千葉県は',
    keywordNumber: '産',
    rememberNumber: '3',
    keywordCity: '梨',
    rememberCity: '千葉',
    dateAisu: '12/10',
    dateTorme: '',
    supplement: '※梨：千葉の名産品',
  },
  {
    length: '4',
    areacode: '0432',
    city: '千葉',
    word: '札で千羽鶴',
    keywordNumber: '札',
    rememberNumber: '32',
    keywordCity: '千羽',
    rememberCity: '千葉',
    dateAisu: '12/10',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0433',
    city: '千葉',
    word: '-',
    keywordNumber: '-',
    rememberNumber: '-',
    keywordCity: '-',
    rememberCity: '-',
    dateAisu: '12/10',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0434',
    city: '千葉',
    word: '-',
    keywordNumber: '-',
    rememberNumber: '-',
    keywordCity: '-',
    rememberCity: '-',
    dateAisu: '12/10',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0436',
    city: '市原',
    word: '寒い！腹だすと',
    keywordNumber: '寒',
    rememberNumber: '36',
    keywordCity: 'い！腹',
    rememberCity: '市原',
    dateAisu: '12/10',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0438',
    city: '木更津',
    word: '砂漠は更地',
    keywordNumber: '砂漠',
    rememberNumber: '38',
    keywordCity: '更',
    rememberCity: '木更津',
    dateAisu: '12/10',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0439',
    city: '君津',
    word: 'キミク',
    keywordNumber: 'ミク',
    rememberNumber: '39',
    keywordCity: 'キミク',
    rememberCity: '君津',
    dateAisu: '12/09',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '044',
    city: '川崎',
    word: '何CCかな?カワサキバイク',
    keywordNumber: 'CC',
    rememberNumber: '44',
    keywordCity: 'カワサキ',
    rememberCity: '川崎',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※カワサキモータースの本社は兵庫県明石市',
  },
  {
    length: '4',
    areacode: '044x',
    city: '川崎',
    word: '何CCかな?カワサキバイク',
    keywordNumber: 'CC',
    rememberNumber: '44',
    keywordCity: 'カワサキ',
    rememberCity: '川崎',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '045',
    city: '横浜',
    word: 'ヨコ',
    keywordNumber: 'ヨコ',
    rememberNumber: '45',
    keywordCity: 'ヨコ',
    rememberCity: '横浜',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '※通信タイムス(1965)「市外局番の語呂合せ」より',
  },
  {
    length: '4',
    areacode: '045x',
    city: '横浜',
    word: 'ヨコ',
    keywordNumber: 'ヨコ',
    rememberNumber: '45',
    keywordCity: 'ヨコ',
    rememberCity: '横浜',
    dateAisu: '10/20',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '046',
    city: '小田原',
    word: '無敵のお城 小田原城',
    keywordNumber: 'お城',
    rememberNumber: '046',
    keywordCity: '小田原城',
    rememberCity: '小田原',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '※小田原城：後北条氏の居城',
  },
  {
    length: '4',
    areacode: '0460',
    city: '箱根',
    word: 'ランナーの群れ 箱根駅伝',
    keywordNumber: '群れ',
    rememberNumber: '60',
    keywordCity: '箱根駅伝',
    rememberCity: '箱根',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※箱根駅伝：東京箱根間往復大学駅伝競走',
  },
  {
    length: '4',
    areacode: '0462',
    city: '厚木',
    word: 'むずむず暑い',
    keywordNumber: 'むずむず',
    rememberNumber: '62',
    keywordCity: '暑い',
    rememberCity: '厚木',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0463',
    city: '平塚',
    word: 'むさい平屋',
    keywordNumber: 'むさ',
    rememberNumber: '63',
    keywordCity: '平',
    rememberCity: '平塚',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0464',
    city: '厚木',
    word: '蒸し暑い',
    keywordNumber: '蒸し',
    rememberNumber: '64',
    keywordCity: '暑い',
    rememberCity: '厚木',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0465',
    city: '小田原',
    word: 'ムゴイ包囲だ小田原征伐',
    keywordNumber: 'ムゴ',
    rememberNumber: '65',
    keywordCity: '小田原征伐',
    rememberCity: '小田原',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※小田原征伐：豊臣秀吉が後北条氏を下した戦役',
  },
  {
    length: '4',
    areacode: '0466',
    city: '藤沢',
    word: 'ろくろっふじ',
    keywordNumber: 'ろくろ',
    rememberNumber: '66',
    keywordCity: 'ふじ',
    rememberCity: '藤沢',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※ろくろ首',
  },
  {
    length: '4',
    areacode: '0467',
    city: '鎌倉',
    word: 'いい胸毛だね鎌倉武士',
    keywordNumber: '胸',
    rememberNumber: '67',
    keywordCity: '鎌倉武士',
    rememberCity: '鎌倉',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※いい胸毛だね清盛さん',
  },
  {
    length: '4',
    areacode: '0468',
    city: '横須賀',
    word: '海軍の牢屋',
    keywordNumber: '牢屋',
    rememberNumber: '68',
    keywordCity: '海軍',
    rememberCity: '横須賀',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※海軍：横須賀は海軍の軍港として栄えた',
  },
  {
    length: '3',
    areacode: '047',
    city: '船橋',
    word: '梨の産地だよ 千葉県は',
    keywordNumber: '梨',
    rememberNumber: '7',
    keywordCity: '梨',
    rememberCity: '千葉',
    dateAisu: '12/19',
    dateTorme: '',
    supplement: '※梨：千葉の名産品',
  },
  {
    length: '4',
    areacode: '0470',
    city: '鴨川',
    word: '鴨になれよ',
    keywordNumber: 'なれ',
    rememberNumber: '70',
    keywordCity: '鴨',
    rememberCity: '鴨川',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0471',
    city: '柏',
    word: '菓子はない',
    keywordNumber: 'ない',
    rememberNumber: '71',
    keywordCity: '菓子は',
    rememberCity: '柏',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※0472は千葉市だったため欠番',
  },
  {
    length: '4',
    areacode: '0473',
    city: '市川',
    word: '波がきちぃ川',
    keywordNumber: 'なみ',
    rememberNumber: '73',
    keywordCity: 'きちぃ川',
    rememberCity: '市川',
    dateAisu: '12/22',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0474',
    city: '船橋',
    word: 'ふなっしー',
    keywordNumber: 'なっしー',
    rememberNumber: '74',
    keywordCity: 'ふなっしー',
    rememberCity: '船橋',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※ふなっしー：船橋市の非公式マスコットキャラ',
  },
  {
    length: '4',
    areacode: '0475',
    city: '茂原',
    word: 'モナコ',
    keywordNumber: 'ナコ',
    rememberNumber: '75',
    keywordCity: 'モ',
    rememberCity: '茂原',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※ヨーロッパの国名',
  },
  {
    length: '4',
    areacode: '0476',
    city: '成田',
    word: 'なろた空港',
    keywordNumber: 'なろ',
    rememberNumber: '76',
    keywordCity: 'なろた空港',
    rememberCity: '成田',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※成田空港：海外への空の玄関口',
  },
  {
    length: '4',
    areacode: '0477',
    city: '船橋',
    word: 'らっきーせぶんなっしー',
    keywordNumber: 'らっきーせぶん',
    rememberNumber: '77',
    keywordCity: 'なっしー',
    rememberCity: '船橋',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0478',
    city: '香取',
    word: '納屋の蚊取り線香',
    keywordNumber: '納屋',
    rememberNumber: '78',
    keywordCity: '蚊取り',
    rememberCity: '香取',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0479',
    city: '銚子',
    word: '調子悪くて泣く',
    keywordNumber: '泣く',
    rememberNumber: '79',
    keywordCity: '調子',
    rememberCity: '銚子',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '048',
    city: '埼玉',
    word: 'やさいたま',
    keywordNumber: 'や',
    rememberNumber: '8',
    keywordCity: 'さいたま',
    rememberCity: '埼玉',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※野菜',
  },
  {
    length: '4',
    areacode: '0480',
    city: '久喜',
    word: 'バレーボールの空気入れ',
    keywordNumber: 'バレー',
    rememberNumber: '80',
    keywordCity: '空気',
    rememberCity: '久喜',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0482',
    city: '川口',
    word: 'パッツンカワイイ',
    keywordNumber: 'パッツン',
    rememberNumber: '82',
    keywordCity: 'カワ',
    rememberCity: '川口',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0483',
    city: '川口',
    word: '-',
    keywordNumber: '',
    rememberNumber: '',
    keywordCity: '',
    rememberCity: '',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0484',
    city: '川口',
    word: '-',
    keywordNumber: '',
    rememberNumber: '',
    keywordCity: '',
    rememberCity: '',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0485',
    city: '熊谷',
    word: '子熊',
    keywordNumber: '子',
    rememberNumber: '5',
    keywordCity: '熊',
    rememberCity: '熊谷',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0486',
    city: 'さいたま',
    word: 'ハムを裂いたま',
    keywordNumber: 'ハム',
    rememberNumber: '86',
    keywordCity: '裂いたま',
    rememberCity: 'さいたま',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0487',
    city: 'さいたま',
    word: '-',
    keywordNumber: '',
    rememberNumber: '',
    keywordCity: '',
    rememberCity: '',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0488',
    city: 'さいたま',
    word: '-',
    keywordNumber: '',
    rememberNumber: '',
    keywordCity: '',
    rememberCity: '',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0489',
    city: '草加',
    word: 'パクパク草加せんべい',
    keywordNumber: 'パクパク',
    rememberNumber: '89',
    keywordCity: '草加せんべい',
    rememberCity: '草加',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※せんべい：草加の名産品',
  },
  {
    length: '3',
    areacode: '049',
    city: '秩父',
    word: 'くさいたま',
    keywordNumber: 'く',
    rememberNumber: '9',
    keywordCity: 'さいたま',
    rememberCity: '埼玉',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※漫画『翔んで埼玉』のセリフに登場',
  },
  {
    length: '4',
    areacode: '0492',
    city: '川越',
    word: '武蔵国 川越',
    keywordNumber: '国',
    rememberNumber: '92',
    keywordCity: '川越',
    rememberCity: '川越',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※武蔵国：江戸幕府のお膝元、川越は小江戸と呼ばれる',
  },
  {
    length: '4',
    areacode: '0493',
    city: '東松山',
    word: '草を待つヤマアラシ',
    keywordNumber: '草',
    rememberNumber: '93',
    keywordCity: '待つヤマ、アラシ',
    rememberCity: '東松山、嵐山',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0494',
    city: '秩父',
    word: '櫛で梳かす父',
    keywordNumber: '櫛',
    rememberNumber: '94',
    keywordCity: '父',
    rememberCity: '秩父',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0495',
    city: '本庄',
    word: '中古本女子',
    keywordNumber: '中古',
    rememberNumber: '95',
    keywordCity: '本女子',
    rememberCity: '本庄市',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0499',
    city: '大島',
    word: 'クック諸島',
    keywordNumber: 'クック',
    rememberNumber: '99',
    keywordCity: '島',
    rememberCity: '大島',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※オセアニアの国名',
  },
  {
    length: '3',
    areacode: '052',
    city: '名古屋',
    word: 'ゴツイ個性の名古屋めし',
    keywordNumber: 'ゴツ',
    rememberNumber: '52',
    keywordCity: '名古屋めし',
    rememberCity: '名古屋',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※名古屋めし：名古屋名物のひつまぶし、味噌カツなど',
  },
  {
    length: '4',
    areacode: '052x',
    city: '名古屋',
    word: '甘党喫茶',
    keywordNumber: '',
    rememberNumber: '',
    keywordCity: '甘、党、喫',
    rememberCity: 'あま、東海、清須',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※喫茶：喫茶マウンテンの抹茶スパが有名',
  },
  {
    length: '3',
    areacode: '053',
    city: '浜松',
    word: '浜松ギョーザ',
    keywordNumber: 'ギョーザ',
    rememberNumber: '53',
    keywordCity: '浜松ギョーザ',
    rememberCity: '浜松',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※浜松餃子：浜松名物',
  },
  {
    length: '4',
    areacode: '0531',
    city: '田原',
    word: '咲いた原',
    keywordNumber: '咲い',
    rememberNumber: '31',
    keywordCity: 'た原',
    rememberCity: '田原',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0532',
    city: '豊橋',
    word: '考察班の端くれ',
    keywordNumber: '考察',
    rememberNumber: '532',
    keywordCity: '端',
    rememberCity: '豊橋',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0533',
    city: '豊川',
    word: 'サラサラ流れる豊かな川',
    keywordNumber: 'サラサラ',
    rememberNumber: '33',
    keywordCity: '豊かな川',
    rememberCity: '豊川',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0534',
    city: '浜松',
    word: 'うなぎの刺身',
    keywordNumber: '刺身',
    rememberNumber: '34',
    keywordCity: 'うなぎ',
    rememberCity: '浜松',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※うなぎ：浜松市の名産品',
  },
  {
    length: '4',
    areacode: '0535',
    city: '浜松',
    word: '-',
    keywordNumber: '-',
    rememberNumber: '-',
    keywordCity: '-',
    rememberCity: '-',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0536',
    city: '新城',
    word: '寒い新雪',
    keywordNumber: '寒',
    rememberNumber: '36',
    keywordCity: '新雪',
    rememberCity: '新城、設楽',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0537',
    city: '掛川',
    word: 'みんながお前の賭けを聞く',
    keywordNumber: 'みんな',
    rememberNumber: '37',
    keywordCity: 'お前、賭け、聞く',
    rememberCity: '御前崎、掛川、菊川',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '　　　　　　　',
  },
  {
    length: '4',
    areacode: '0538',
    city: '磐田',
    word: 'サンバで祝った',
    keywordNumber: 'サンバ',
    rememberNumber: '38',
    keywordCity: '祝った',
    rememberCity: '磐田',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0539',
    city: '浜松',
    word: '浜松の技術 初音ミク',
    keywordNumber: 'ミク',
    rememberNumber: '39',
    keywordCity: '初音ミク',
    rememberCity: '浜松',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※初音ミク：VOCALOIDは浜松に本社があるYAMAHA由来',
  },
  {
    length: '3',
    areacode: '054',
    city: '静岡',
    word: '静岡',
    keywordNumber: '静',
    rememberNumber: '4',
    keywordCity: '静岡',
    rememberCity: '静岡',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0542',
    city: '静岡',
    word: '静岡',
    keywordNumber: '静',
    rememberNumber: '42',
    keywordCity: '静岡',
    rememberCity: '静岡',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0543',
    city: '静岡',
    word: '-',
    keywordNumber: '-',
    rememberNumber: '-',
    keywordCity: '-',
    rememberCity: '-',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0544',
    city: '富士宮',
    word: 'よきよき！ 富士宮焼きそば',
    keywordNumber: 'よきよき',
    rememberNumber: '44',
    keywordCity: '富士宮焼きそば',
    rememberCity: '富士宮',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※富士宮焼きそば：富士宮名物',
  },
  {
    length: '4',
    areacode: '0545',
    city: '富士',
    word: '四股踏む富士のお相撲さん',
    keywordNumber: '四股',
    rememberNumber: '45',
    keywordCity: '富士',
    rememberCity: '富士',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※富士：千代の富士や日馬富士らが有名',
  },
  {
    length: '4',
    areacode: '0546',
    city: '静岡',
    word: 'しむおか',
    keywordNumber: 'しむ',
    rememberNumber: '46',
    keywordCity: 'しむおか',
    rememberCity: '静岡',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0547',
    city: '島田',
    word: 'シナダ',
    keywordNumber: 'シナ',
    rememberNumber: '47',
    keywordCity: 'シナダ',
    rememberCity: '島田',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0548',
    city: '牧之原',
    word: 'シワシワの巻物',
    keywordNumber: 'シワシワ',
    rememberNumber: '48',
    keywordCity: '巻',
    rememberCity: '牧之原',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0549',
    city: '静岡',
    word: 'よく出る静岡',
    keywordNumber: 'よく',
    rememberNumber: '49',
    keywordCity: '静岡',
    rememberCity: '静岡',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '055',
    city: '甲府',
    word: '甲府',
    keywordNumber: '甲',
    rememberNumber: '5',
    keywordCity: '甲府',
    rememberCity: '甲府',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0550',
    city: '御殿場',
    word: '御殿場',
    keywordNumber: '御殿',
    rememberNumber: '50',
    keywordCity: '御殿場',
    rememberCity: '御殿場',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0551',
    city: '韮崎',
    word: 'ココイチ ニラカレー',
    keywordNumber: 'ココイチ',
    rememberNumber: '551',
    keywordCity: 'ニラ',
    rememberCity: '韮崎',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※CoCo壱番屋(ココイチ)：カレーチェーン店',
  },
  {
    length: '4',
    areacode: '0552',
    city: '甲府',
    word: '甲府',
    keywordNumber: '甲府',
    rememberNumber: '52',
    keywordCity: '甲府',
    rememberCity: '甲府',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0553',
    city: '山梨',
    word: 'ごみの山無し',
    keywordNumber: 'ごみ',
    rememberNumber: '53',
    keywordCity: '山無し',
    rememberCity: '山梨',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0554',
    city: '大月',
    word: '今宵の大きい月',
    keywordNumber: '今宵',
    rememberNumber: '54',
    keywordCity: '大きな月',
    rememberCity: '大月',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0555',
    city: '富士吉田',
    word: 'ゴーゴーゴー！ 富士急ハイランド',
    keywordNumber: 'ゴーゴーゴー！',
    rememberNumber: '555',
    keywordCity: '富士急ハイランド',
    rememberCity: '富士吉田',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※富士急ハイランド：富士吉田市の遊園地',
  },
  {
    length: '4',
    areacode: '0556',
    city: '富士川',
    word: '日本の心 富士と川',
    keywordNumber: '心',
    rememberNumber: '556',
    keywordCity: '富士と川',
    rememberCity: '富士川',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0557',
    city: '熱海',
    word: 'ココナッツは熱い海で',
    keywordNumber: 'ココナッツ',
    rememberNumber: '557',
    keywordCity: '熱い海',
    rememberCity: '熱海',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0558',
    city: '下田',
    word: '霜だ！ココア飲も',
    keywordNumber: 'ココア',
    rememberNumber: '558',
    keywordCity: '霜だ',
    rememberCity: '下田',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0559',
    city: '沼津',
    word: 'まずい！ゴクゴク',
    keywordNumber: 'ゴクゴク',
    rememberNumber: '59',
    keywordCity: '沼津',
    rememberCity: 'まず',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '056',
    city: '豊田',
    word: 'コロコロトヨタ',
    keywordNumber: 'コロコロ',
    rememberNumber: '56',
    keywordCity: 'トヨタ',
    rememberCity: '豊田',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※トヨタ：豊田市に本社がある自動車メーカー',
  },
  {
    length: '4',
    areacode: '0561',
    city: '瀬戸',
    word: '瀬戸際公務員',
    keywordNumber: '公務員',
    rememberNumber: '561',
    keywordCity: '瀬戸',
    rememberCity: '瀬戸',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0562',
    city: '知多',
    word: 'むつごろうVSチーター',
    keywordNumber: 'むつ',
    rememberNumber: '62',
    keywordCity: 'チーター',
    rememberCity: '知多',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※むつごろう：畑正憲(動物研究家)',
  },
  {
    length: '4',
    areacode: '0563',
    city: '西尾',
    word: '無味に塩',
    keywordNumber: '無味',
    rememberNumber: '63',
    keywordCity: 'に塩',
    rememberCity: '西尾',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0564',
    city: '岡崎',
    word: '蒸しておかなきゃ',
    keywordNumber: '蒸し',
    rememberNumber: '64',
    keywordCity: 'おか',
    rememberCity: '岡崎',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0565',
    city: '豊田',
    word: 'コロコロトヨタ',
    keywordNumber: 'コロコロ',
    rememberNumber: '56',
    keywordCity: 'トヨタ',
    rememberCity: '豊田',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0566',
    city: '刈谷',
    word: 'ろくろを借りた',
    keywordNumber: 'ろくろ',
    rememberNumber: '66',
    keywordCity: '借りた',
    rememberCity: '刈谷',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0567',
    city: '津島',
    word: 'コロナになっつしまった',
    keywordNumber: 'コロナ',
    rememberNumber: '567',
    keywordCity: 'つしま',
    rememberCity: '津島',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0568',
    city: '春日井',
    word: 'ロバを貸すがいい',
    keywordNumber: 'ロバ',
    rememberNumber: '68',
    keywordCity: '貸すがいい',
    rememberCity: '春日井',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0569',
    city: '半田',
    word: '無垢なパンダ',
    keywordNumber: '無垢',
    rememberNumber: '69',
    keywordCity: 'パンダ',
    rememberCity: '半田',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '057',
    city: '多治見',
    word: '困難たじたじ',
    keywordNumber: '困難',
    rememberNumber: '57',
    keywordCity: 'たじたじ',
    rememberCity: '多治見',
    dateAisu: '12/23',
    dateTorme: '',
    supplement: '※',
  },
  {
    length: '4',
    areacode: '0572',
    city: '多治見',
    word: '困難にたじたじ',
    keywordNumber: '困難に',
    rememberNumber: '572',
    keywordCity: 'たじたじ',
    rememberCity: '多治見',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0573',
    city: '恵那',
    word: 'コナミええなぁ',
    keywordNumber: 'コナミ',
    rememberNumber: '573',
    keywordCity: 'ええなぁ',
    rememberCity: '恵那',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※コナミ：ゲーム会社',
  },
  {
    length: '4',
    areacode: '0574',
    city: '可児',
    word: 'やまなしの蟹',
    keywordNumber: 'なし',
    rememberNumber: '74',
    keywordCity: '蟹',
    rememberCity: '蟹江',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※やまなし：宮沢賢治の童話',
  },
  {
    length: '4',
    areacode: '0575',
    city: '関',
    word: '五七五じゃない 咳をしても一人',
    keywordNumber: '五七五',
    rememberNumber: '575',
    keywordCity: '咳',
    rememberCity: '関',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※咳をしても一人：尾崎放哉の俳句',
  },
  {
    length: '4',
    areacode: '0576',
    city: '下呂',
    word: 'ゲロゲロになろう！',
    keywordNumber: 'なろう',
    rememberNumber: '76',
    keywordCity: 'ゲロゲロ',
    rememberCity: '下呂',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0577',
    city: '高山',
    word: 'ラッキーセブンで宝の山',
    keywordNumber: 'ラッキーセブン',
    rememberNumber: '77',
    keywordCity: '宝の山',
    rememberCity: '高山',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0578',
    city: '飛騨',
    word: '納屋に被弾',
    keywordNumber: '納屋',
    rememberNumber: '78',
    keywordCity: '被弾',
    rememberCity: '飛騨',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '058',
    city: '岐阜',
    word: 'ごはんを寄付',
    keywordNumber: 'ごはん',
    rememberNumber: '58',
    keywordCity: '寄付',
    rememberCity: '岐阜',
    dateAisu: '12/23',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0581',
    city: '本巣',
    word: '牌を戻す',
    keywordNumber: '牌',
    rememberNumber: '81',
    keywordCity: '戻すし',
    rememberCity: '本巣',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※麻雀のルールで禁止されている',
  },
  {
    length: '4',
    areacode: '0582',
    city: '岐阜',
    word: 'ごはんつぶを寄付',
    keywordNumber: 'ごはんつ',
    rememberNumber: '582',
    keywordCity: '寄付',
    rememberCity: '岐阜',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0583',
    city: '岐阜',
    word: '-',
    keywordNumber: '-',
    rememberNumber: '-',
    keywordCity: '-',
    rememberCity: '-',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0584',
    city: '大垣',
    word: '走るガキ大将',
    keywordNumber: '走',
    rememberNumber: '84',
    keywordCity: 'ガキ大',
    rememberCity: '大垣',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0585',
    city: '揖斐川',
    word: '箱いび娘',
    keywordNumber: '箱',
    rememberNumber: '85',
    keywordCity: 'いび',
    rememberCity: '揖斐川',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※箱入り娘',
  },
  {
    length: '4',
    areacode: '0586',
    city: '一宮',
    word: 'はろーみや',
    keywordNumber: 'はろ',
    rememberNumber: '86',
    keywordCity: 'ーみや',
    rememberCity: '一宮',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0587',
    city: '稲沢',
    word: 'バナナ稲作',
    keywordNumber: 'バナナ',
    rememberNumber: '87',
    keywordCity: '稲',
    rememberCity: '稲沢',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '059',
    city: '三重',
    word: '見栄張る王国',
    keywordNumber: '王国',
    rememberNumber: '059',
    keywordCity: '見栄',
    rememberCity: '三重',
    dateAisu: '12/23',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0592',
    city: '津',
    word: '苦痛',
    keywordNumber: '苦痛',
    rememberNumber: '92',
    keywordCity: '痛',
    rememberCity: '津',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0593',
    city: '四日市',
    word: '四日坊主のコックさん',
    keywordNumber: 'コックさん',
    rememberNumber: '593',
    keywordCity: '四日',
    rememberCity: '四日市',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0594',
    city: '桑名',
    word: '国士の罠',
    keywordNumber: '国士',
    rememberNumber: '594',
    keywordCity: '罠',
    rememberCity: '桑名',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※国士：国士無双の略。麻雀の役',
  },
  {
    length: '4',
    areacode: '0595',
    city: '亀山',
    word: '国語の亀さん',
    keywordNumber: '国語',
    rememberNumber: '595',
    keywordCity: '亀さん',
    rememberCity: '亀山',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0596',
    city: '伊勢',
    word: 'ご苦労様ですお伊勢参り',
    keywordNumber: 'ご苦労',
    rememberNumber: '596',
    keywordCity: 'お伊勢参り',
    rememberCity: '伊勢',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※お伊勢参り：伊勢神宮へ参拝すること',
  },
  {
    length: '4',
    areacode: '0597',
    city: '尾鷲',
    word: '国難オワタ',
    keywordNumber: '国難',
    rememberNumber: '597',
    keywordCity: 'オワ',
    rememberCity: '尾鷲',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0598',
    city: '松阪',
    word: '松阪牛クッパ',
    keywordNumber: 'クッパ',
    rememberNumber: '98',
    keywordCity: '松阪牛',
    rememberCity: '松阪',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※松阪牛：松阪市の名産品',
  },
  {
    length: '4',
    areacode: '0599',
    city: '鳥羽',
    word: 'キュンキュンする言葉',
    keywordNumber: 'キュンキュン',
    rememberNumber: '99',
    keywordCity: '言葉',
    rememberCity: '鳥羽',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '06 ',
    city: '大阪',
    word: 'オムそば',
    keywordNumber: 'オム',
    rememberNumber: '06',
    keywordCity: 'オムそば',
    rememberCity: '大阪',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※オムそば：大阪発祥の料理',
  },
  {
    length: '2',
    areacode: '06',
    city: '尼崎',
    word: 'オムレットは甘い',
    keywordNumber: 'オムレット',
    rememberNumber: '06',
    keywordCity: '甘い',
    rememberCity: '尼崎',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '072',
    city: '堺',
    word: '夏色 坂を下っていく',
    keywordNumber: '夏',
    rememberNumber: '72',
    keywordCity: '坂',
    rememberCity: '堺',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※夏色：ゆずの代表曲',
  },
  {
    length: '4',
    areacode: '0721',
    city: '富田林',
    word: 'なにい！？林が飛んだ！？',
    keywordNumber: 'なにい',
    rememberNumber: '721',
    keywordCity: '林が飛んだ',
    rememberCity: '',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0722',
    city: '堺',
    word: '夏に坂を下っていく',
    keywordNumber: '夏に',
    rememberNumber: '722',
    keywordCity: '坂',
    rememberCity: '堺',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0723',
    city: '堺',
    word: '-',
    keywordNumber: '-',
    rememberNumber: '-',
    keywordCity: '-',
    rememberCity: '-',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0724',
    city: '岸和田',
    word: 'にしわだ',
    keywordNumber: 'にし',
    rememberNumber: '24',
    keywordCity: 'にしわだ',
    rememberCity: '岸和田',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0725',
    city: '和泉',
    word: 'ニコニコはワイのおかげ',
    keywordNumber: 'ニコニコ',
    rememberNumber: '25',
    keywordCity: 'わい',
    rememberCity: '和泉',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※和泉の読みは正しくは「わいずみ」ではなく「いずみ」',
  },
  {
    length: '4',
    areacode: '0726',
    city: '茨木',
    word: '通路は茨の道',
    keywordNumber: '通路',
    rememberNumber: '26',
    keywordCity: '茨',
    rememberCity: '茨木',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0727',
    city: '池田',
    word: 'ツナの池だ',
    keywordNumber: 'ツナ',
    rememberNumber: '27',
    keywordCity: '池だ',
    rememberCity: '池田',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0728',
    city: '寝屋川',
    word: 'ニヤガワ',
    keywordNumber: 'ニヤ',
    rememberNumber: '28',
    keywordCity: 'ニヤガワ',
    rememberCity: '寝屋川',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0729',
    city: '八尾',
    word: '肉屋と八百屋',
    keywordNumber: '肉',
    rememberNumber: '29',
    keywordCity: '八百',
    rememberCity: '八尾',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '073',
    city: '和歌山',
    word: 'ミカンの 和歌山県',
    keywordNumber: 'ミカン',
    rememberNumber: '3',
    keywordCity: 'ミカン',
    rememberCity: '和歌山',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※ミカン：和歌山県の名産品',
  },
  {
    length: '4',
    areacode: '0734',
    city: '和歌山',
    word: '民謡と和歌',
    keywordNumber: '民謡',
    rememberNumber: '34',
    keywordCity: '和歌',
    rememberCity: '和歌山',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0735',
    city: '新宮',
    word: 'サンゴの竜宮',
    keywordNumber: 'サンゴ',
    rememberNumber: '35',
    keywordCity: '竜宮',
    rememberCity: '新宮',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0736',
    city: '橋本',
    word: '寒い足元',
    keywordNumber: '寒',
    rememberNumber: '36',
    keywordCity: '足元',
    rememberCity: '橋本',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0737',
    city: '有田',
    word: '並々ならぬ有田みかん',
    keywordNumber: '並々な',
    rememberNumber: '737',
    keywordCity: '有田みかん',
    rememberCity: '有田',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※有田みかん：有田市の名産品',
  },
  {
    length: '4',
    areacode: '0738',
    city: '御坊',
    word: '鯖のごぼう煮',
    keywordNumber: '鯖',
    rememberNumber: '38',
    keywordCity: 'ごぼう',
    rememberCity: '御坊',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0739',
    city: '田辺',
    word: 'ざく切り鍋',
    keywordNumber: 'ざく',
    rememberNumber: '39',
    keywordCity: '鍋',
    rememberCity: '田辺',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '074',
    city: '奈良',
    word: 'シカたちの 奈良公園',
    keywordNumber: 'シカ',
    rememberNumber: '4',
    keywordCity: 'シカ',
    rememberCity: '奈良',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※奈良公園：シカが国の天然記念物に指定されている',
  },
  {
    length: '4',
    areacode: '0740',
    city: '高島',
    word: 'たかしまん',
    keywordNumber: 'しまん',
    rememberNumber: '40',
    keywordCity: 'たかしま',
    rememberCity: '高島',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0742',
    city: '奈良',
    word: '静かに奈良漬け',
    keywordNumber: '静',
    rememberNumber: '42',
    keywordCity: '奈良漬け',
    rememberCity: '奈良',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※奈良漬け：奈良名物の漬物',
  },
  {
    length: '4',
    areacode: '0743',
    city: '生駒',
    word: '予算困った',
    keywordNumber: '予算',
    rememberNumber: '43',
    keywordCity: '困った',
    rememberCity: '生駒',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0744',
    city: '桜井',
    word: '夜々桜',
    keywordNumber: '夜々',
    rememberNumber: '44',
    keywordCity: '桜',
    rememberCity: '桜井',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0745',
    city: '大和高田',
    word: '仕事だから大和高田',
    keywordNumber: '仕事',
    rememberNumber: '45',
    keywordCity: 'だから',
    rememberCity: '大和高田',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0746',
    city: '吉野',
    word: '素人はよしな',
    keywordNumber: '素',
    rememberNumber: '46',
    keywordCity: 'よしな',
    rememberCity: '吉野',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0747',
    city: '五條',
    word: 'ナヨナヨな御嬢',
    keywordNumber: 'ナヨナヨな',
    rememberNumber: '747',
    keywordCity: '御嬢',
    rememberCity: '五條',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0748',
    city: '近江八幡',
    word: '八幡',
    keywordNumber: '八',
    rememberNumber: '8',
    keywordCity: '八幡',
    rememberCity: '近江八幡',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0749',
    city: '彦根',
    word: '欲張りひこにゃん',
    keywordNumber: '欲',
    rememberNumber: '49',
    keywordCity: 'ひこにゃん',
    rememberCity: '彦根',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※ひこにゃん：彦根市のマスコットキャラ',
  },
  {
    length: '3',
    areacode: '075',
    city: '京都',
    word: '女子(おなご)は京美人',
    keywordNumber: '女子',
    rememberNumber: '075',
    keywordCity: '京美人',
    rememberCity: '京都',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '※京美人：日本三大美人',
  },
  {
    length: '4',
    areacode: '075x',
    city: '京都',
    word: '向こうに長髪柔肌少女',
    keywordNumber: '',
    rememberNumber: '',
    keywordCity: '向こう、長、柔、少女',
    rememberCity: '向日、長岡京、八幡、京都',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '076',
    city: '金沢富山',
    word: 'なろうよ金持ち大富豪',
    keywordNumber: 'なろう',
    rememberNumber: '76',
    keywordCity: '金、富豪',
    rememberCity: '金沢、富山',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0761',
    city: '小松',
    word: '剥いた小松菜',
    keywordNumber: '剥い',
    rememberNumber: '61',
    keywordCity: '小松',
    rememberCity: '小松',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0762',
    city: '金沢',
    word: 'ローズゴールド',
    keywordNumber: 'ローズ',
    rememberNumber: '62',
    keywordCity: 'ゴールド',
    rememberCity: '金沢',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※金に銀・銅を混ぜた混合物',
  },
  {
    length: '4',
    areacode: '0763',
    city: '砺波',
    word: '√3 : 人並みに',
    keywordNumber: '√3',
    rememberNumber: '63',
    keywordCity: '人並み',
    rememberCity: '砺波',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※人並みにおごれや(√3の語呂合わせ)',
  },
  {
    length: '4',
    areacode: '0764',
    city: '富山',
    word: '虫の山',
    keywordNumber: '虫',
    rememberNumber: '64',
    keywordCity: 'の山',
    rememberCity: '富山',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0765',
    city: '魚津',
    word: 'サカナムコ',
    keywordNumber: 'ナムコ',
    rememberNumber: '765',
    keywordCity: 'サカナ',
    rememberCity: '魚津',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0766',
    city: '高岡',
    word: 'ろくろが高い',
    keywordNumber: 'ろくろ',
    rememberNumber: '66',
    keywordCity: '買おうか',
    rememberCity: '高岡',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0767',
    city: '七尾',
    word: '七尾',
    keywordNumber: '七',
    rememberNumber: '7',
    keywordCity: '七尾',
    rememberCity: '七尾',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0768',
    city: '輪島',
    word: 'ハジマ',
    keywordNumber: 'ハ',
    rememberNumber: '8',
    keywordCity: 'ハジマ',
    rememberCity: '輪島',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '077',
    city: '京都大津福井',
    word: 'なんなん！？この割り振られ方',
    keywordNumber: 'なんなん',
    rememberNumber: '77',
    keywordCity: 'この割り振られ方',
    rememberCity: '京都、大津、福井',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0770',
    city: '小浜',
    word: '馴れ馴れしいオバマ',
    keywordNumber: '馴れ馴れ',
    rememberNumber: '70',
    keywordCity: 'オバマ',
    rememberCity: '小浜',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0771',
    city: '亀岡',
    word: '噛めない',
    keywordNumber: 'ない',
    rememberNumber: '71',
    keywordCity: '噛め',
    rememberCity: '亀岡',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0772',
    city: '宮津',
    word: '夏やずみ',
    keywordNumber: '夏',
    rememberNumber: '72',
    keywordCity: 'やずみ',
    rememberCity: '宮津',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0773',
    city: '福知山',
    word: '涙を拭く知山',
    keywordNumber: '涙',
    rememberNumber: '73',
    keywordCity: '拭く知山',
    rememberCity: '福知山',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0774',
    city: '宇治',
    word: '宇治',
    keywordNumber: '治',
    rememberNumber: '4',
    keywordCity: '宇治',
    rememberCity: '宇治',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0775',
    city: '大津',
    word: 'ナナコで買おおつ！',
    keywordNumber: 'ナナコ',
    rememberNumber: '775',
    keywordCity: 'おおつ',
    rememberCity: '大津',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※ナナコ：電子決済サービス',
  },
  {
    length: '4',
    areacode: '0776',
    city: '福井',
    word: '南無で冥福祈ります',
    keywordNumber: '南無',
    rememberNumber: '76',
    keywordCity: '福祈',
    rememberCity: '福井',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0778',
    city: '鯖江',
    word: '名ばかりのサーバーへ',
    keywordNumber: '名ば',
    rememberNumber: '78',
    keywordCity: 'サーバーへ',
    rememberCity: '鯖江',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0779',
    city: '大野',
    word: '泣く泣くOh NO!',
    keywordNumber: '泣く泣く',
    rememberNumber: '79',
    keywordCity: 'OhNo',
    rememberCity: '大野',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '078',
    city: '神戸',
    word: 'ハーバーランド 神戸港',
    keywordNumber: 'ハ',
    rememberNumber: '8',
    keywordCity: '神戸港',
    rememberCity: '神戸',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※ハーバーランド：神戸港周辺の再開発地域',
  },
  {
    length: '4',
    areacode: '078x',
    city: '神戸',
    word: '明るいハーバー',
    keywordNumber: '',
    rememberNumber: '',
    keywordCity: '明',
    rememberCity: '明石',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '079',
    city: '姫路',
    word: 'クイーンの姫路城',
    keywordNumber: 'クイーン',
    rememberNumber: '9',
    keywordCity: '姫路城',
    rememberCity: '姫路',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※姫路城：徳川家康の孫娘、千姫が有名',
  },
  {
    length: '4',
    areacode: '0790',
    city: '加西',
    word: '火災保険くれ！',
    keywordNumber: 'くれ',
    rememberNumber: '90',
    keywordCity: '火災',
    rememberCity: '加西',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0791',
    city: 'たつの',
    word: '悔いは先に立つの？',
    keywordNumber: '悔い',
    rememberNumber: '91',
    keywordCity: 'たつの',
    rememberCity: 'たつの',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※後悔先に立たず',
  },
  {
    length: '4',
    areacode: '0792',
    city: '姫路',
    word: '国のクイーン',
    keywordNumber: '国',
    rememberNumber: '92',
    keywordCity: 'クイーン',
    rememberCity: '姫路',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0793',
    city: '姫路',
    word: '-',
    keywordNumber: '-',
    rememberNumber: '-',
    keywordCity: '-',
    rememberCity: '-',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0794',
    city: '加古川',
    word: '棋士のまち 加古川',
    keywordNumber: '棋士',
    rememberNumber: '94',
    keywordCity: '棋士のまち',
    rememberCity: '加古川',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※棋士のまち：加古川市がプロ棋士を多く輩出したことから',
  },
  {
    length: '4',
    areacode: '0795',
    city: '三田',
    word: '泣く子にサンダー',
    keywordNumber: '泣く子',
    rememberNumber: '795',
    keywordCity: 'サンダー',
    rememberCity: '三田',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0796',
    city: '豊岡',
    word: '黒いタピオカ',
    keywordNumber: '黒',
    rememberNumber: '96',
    keywordCity: 'オカ',
    rememberCity: '豊岡',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0797',
    city: '宝塚',
    word: '泣くな 宝塚歌劇団',
    keywordNumber: '泣くな',
    rememberNumber: '797',
    keywordCity: '宝塚歌劇団',
    rememberCity: '宝塚',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※宝塚歌劇団：宝塚市を拠点にする劇団',
  },
  {
    length: '4',
    areacode: '0798',
    city: '西宮',
    word: 'キューバは西が嫌',
    keywordNumber: 'キューバ',
    rememberNumber: '98',
    keywordCity: '西が嫌',
    rememberCity: '西宮',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※キューバは社会主義国家',
  },
  {
    length: '4',
    areacode: '0799',
    city: '淡路',
    word: '救急車 間に合わじ',
    keywordNumber: '救急',
    rememberNumber: '99',
    keywordCity: '合わじ',
    rememberCity: '淡路',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※間に合わじ：将棋棋士豊川七段の名言',
  },
  {
    length: '3',
    areacode: '082',
    city: '広島',
    word: 'おやつは広島もみじ饅頭',
    keywordNumber: 'おやつ',
    rememberNumber: '082',
    keywordCity: 'もみじ饅頭',
    rememberCity: '広島',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※もみじ饅頭：広島名物の饅頭',
  },
  {
    length: '4',
    areacode: '0820',
    city: '柳井',
    word: 'ノーパンやないかい！',
    keywordNumber: 'ノーパン',
    rememberNumber: '0820',
    keywordCity: 'やない',
    rememberCity: '柳井',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※ノーパン：おぱんつゼロを指す',
  },
  {
    length: '4',
    areacode: '0822',
    city: '広島',
    word: 'バットふりふり広島カープ',
    keywordNumber: 'バットフリフリ',
    rememberNumber: '822',
    keywordCity: '広島カープ',
    rememberCity: '広島',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※通信タイムス(1965)「市外局番の語呂合せ」より',
  },
  {
    length: '4',
    areacode: '0823',
    city: '呉',
    word: '兄さんをくれ！',
    keywordNumber: '兄さん',
    rememberNumber: '23',
    keywordCity: 'くれ',
    rememberCity: '呉',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0824',
    city: '三次',
    word: 'にじさんじ',
    keywordNumber: 'にじ',
    rememberNumber: '24',
    keywordCity: 'さんじ',
    rememberCity: '三次',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※三次の読みは「みよし」 ※にじさんじ：VTuberのグループ',
  },
  {
    length: '4',
    areacode: '0825',
    city: '広島',
    word: 'ニコニコヒーロー',
    keywordNumber: 'ニコニコ',
    rememberNumber: '25',
    keywordCity: 'ヒーロー',
    rememberCity: '広島',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0826',
    city: '安芸高田',
    word: '風呂は飽きた',
    keywordNumber: '風呂',
    rememberNumber: '26',
    keywordCity: '飽きた',
    rememberCity: '安芸高田',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0827',
    city: '岩国',
    word: 'ツナマヨ岩のり',
    keywordNumber: 'ツナ',
    rememberNumber: '27',
    keywordCity: '岩',
    rememberCity: '岩国',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0828',
    city: '広島',
    word: 'ニヤニヤヒーロー',
    keywordNumber: 'ニヤニヤ',
    rememberNumber: '28',
    keywordCity: 'ヒーロー',
    rememberCity: '広島',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0829',
    city: '廿日市',
    word: '肉が甘くない',
    keywordNumber: '肉',
    rememberNumber: '29',
    keywordCity: '甘くない',
    rememberCity: '廿日市',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※甘日市ではなく廿日市(はつかいち)',
  },
  {
    length: '3',
    areacode: '083',
    city: '山口',
    word: '闇で危険な山口県',
    keywordNumber: '闇',
    rememberNumber: '83',
    keywordCity: '闇で危険',
    rememberCity: '山口県',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0832',
    city: '下関',
    word: '雑な下ネタ',
    keywordNumber: '雑',
    rememberNumber: '32',
    keywordCity: '下',
    rememberCity: '下関',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0833',
    city: '下松',
    word: '散々くだらない話をされる',
    keywordNumber: '散々',
    rememberNumber: '33',
    keywordCity: 'くだ',
    rememberCity: '下松',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0834',
    city: '周南',
    word: 'ばさしゅーなん',
    keywordNumber: 'ばさし',
    rememberNumber: '834',
    keywordCity: 'しゅーなん',
    rememberCity: '周南',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0835',
    city: '防府',
    word: 'ザコを防ぐ',
    keywordNumber: 'ザコ',
    rememberNumber: '35',
    keywordCity: '防',
    rememberCity: '防府',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0836',
    city: '宇部',
    word: '挟む→うげ',
    keywordNumber: '挟む',
    rememberNumber: '836',
    keywordCity: 'うげ',
    rememberCity: '宇部',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0837',
    city: '長門',
    word: '長門',
    keywordNumber: '長',
    rememberNumber: '7',
    keywordCity: '長門',
    rememberCity: '長門',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0838',
    city: '萩',
    word: '萩',
    keywordNumber: '萩',
    rememberNumber: '8',
    keywordCity: '萩',
    rememberCity: '萩',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0839',
    city: '山口',
    word: 'やみぐち',
    keywordNumber: 'やみぐ',
    rememberNumber: '839',
    keywordCity: 'やみぐち',
    rememberCity: '山口',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '084',
    city: '福山',
    word: '端まで拭くやま',
    keywordNumber: '端',
    rememberNumber: '84',
    keywordCity: '拭くやま',
    rememberCity: '福山',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0845',
    city: '尾道',
    word: '横道尾道',
    keywordNumber: '横',
    rememberNumber: '45',
    keywordCity: '尾道',
    rememberCity: '尾道',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0846',
    city: '竹原',
    word: '城に竹槍',
    keywordNumber: '城',
    rememberNumber: '46',
    keywordCity: '竹',
    rememberCity: '竹原',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0847',
    city: '府中',
    word: '世直し中',
    keywordNumber: '世直',
    rememberNumber: '47',
    keywordCity: '中',
    rememberCity: '府中',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0848',
    city: '三原',
    word: '視野に見晴らし',
    keywordNumber: '視野',
    rememberNumber: '48',
    keywordCity: '見晴らし',
    rememberCity: '三原市',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0849',
    city: '福山',
    word: 'よく拭くやま',
    keywordNumber: 'よく',
    rememberNumber: '49',
    keywordCity: '拭くやま',
    rememberCity: '福山',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '085',
    city: '鳥取島根',
    word: '親子で覚える にしまね とうっとり',
    keywordNumber: '親子',
    rememberNumber: '085',
    keywordCity: 'にしまね、とうっとり',
    rememberCity: '島根、鳥取',
    dateAisu: '',
    dateTorme: '',
    supplement: '※鳥取島根の位置の覚え方',
  },
  {
    length: '4',
    areacode: '0851',
    city: '隠岐の島',
    word: '箱入り隠し子',
    keywordNumber: '箱入',
    rememberNumber: '851',
    keywordCity: '隠',
    rememberCity: '隠岐の島',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※箱入り娘',
  },
  {
    length: '4',
    areacode: '0852',
    city: '松江',
    word: '箱庭で待つえ',
    keywordNumber: '箱庭',
    rememberNumber: '852',
    keywordCity: '待つえ',
    rememberCity: '松江',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0853',
    city: '出雲',
    word: '古参は出雲そば',
    keywordNumber: '古参',
    rememberNumber: '53',
    keywordCity: '出雲そば',
    rememberCity: '出雲',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※出雲そば：出雲名物、桃鉄でも有名',
  },
  {
    length: '4',
    areacode: '0854',
    city: '安来',
    word: 'ゴシゴシやすり',
    keywordNumber: 'ゴシゴシ',
    rememberNumber: '54',
    keywordCity: 'やすり',
    rememberCity: '安来',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0855',
    city: '浜田',
    word: 'ゴリラ浜田',
    keywordNumber: 'ゴリラ',
    rememberNumber: '5',
    keywordCity: '浜田',
    rememberCity: '浜田',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※浜田：浜田雅功(お笑いタレント)、ゴリラのコラ画像が有名',
  },
  {
    length: '4',
    areacode: '0856',
    city: '益田',
    word: '航路を決めてマストを立てろ',
    keywordNumber: '航路',
    rememberNumber: '56',
    keywordCity: 'マスト',
    rememberCity: '益田',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0857',
    city: '鳥取',
    word: '粉が舞い上がる鳥取砂丘',
    keywordNumber: '粉',
    rememberNumber: '57',
    keywordCity: '砂丘',
    rememberCity: '鳥取',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※鳥取砂丘：代表的な海岸砂丘',
  },
  {
    length: '4',
    areacode: '0858',
    city: '倉吉',
    word: '今夜くらいヨシ！',
    keywordNumber: '今夜',
    rememberNumber: '58',
    keywordCity: 'くらいヨシ！',
    rememberCity: '倉吉',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0859',
    city: '米子',
    word: '号泣の迷子',
    keywordNumber: '号泣',
    rememberNumber: '59',
    keywordCity: '迷子',
    rememberCity: '米子',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '086',
    city: '岡山',
    word: 'HELLO! 大都会岡山県',
    keywordNumber: 'HELLO!',
    rememberNumber: '86',
    keywordCity: '大都会',
    rememberCity: '岡山',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '※大都会岡山：ネットスラング',
  },
  {
    length: '4',
    areacode: '0862',
    city: '岡山',
    word: '浪人ももたろう',
    keywordNumber: '浪人',
    rememberNumber: '62',
    keywordCity: 'ももたろう',
    rememberCity: '岡山',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※ももたろう：岡山が発祥地とされる',
  },
  {
    length: '4',
    areacode: '0863',
    city: '玉野',
    word: '無産階級玉の輿',
    keywordNumber: '無産',
    rememberNumber: '63',
    keywordCity: '玉の',
    rememberCity: '玉野',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0864',
    city: '倉敷',
    word: '羽虫らしきもの',
    keywordNumber: '羽虫',
    rememberNumber: '864',
    keywordCity: 'らしき',
    rememberCity: '倉敷',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0865',
    city: '笠岡',
    word: '婿に傘を貸す',
    keywordNumber: '婿',
    rememberNumber: '65',
    keywordCity: '傘を貸',
    rememberCity: '笠岡',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0866',
    city: '高梁',
    word: 'ろくろが高い',
    keywordNumber: 'ろくろ',
    rememberNumber: '66',
    keywordCity: '高い',
    rememberCity: '高梁',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0867',
    city: '新見',
    word: 'むなしいみ',
    keywordNumber: 'むな',
    rememberNumber: '67',
    keywordCity: 'しいみ',
    rememberCity: '新見',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0868',
    city: '津山',
    word: '老婆つやつや',
    keywordNumber: '老婆',
    rememberNumber: '68',
    keywordCity: 'つやつや',
    rememberCity: '津山',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0869',
    city: '備前',
    word: 'ロックに備えよ',
    keywordNumber: 'ロック',
    rememberNumber: '69',
    keywordCity: '備',
    rememberCity: '備前',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '087',
    city: '香川',
    word: '花の香り',
    keywordNumber: '花',
    rememberNumber: '87',
    keywordCity: '香',
    rememberCity: '香川',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0875',
    city: '観音寺',
    word: 'ハナコ観念しろ',
    keywordNumber: 'ハナコ',
    rememberNumber: '875',
    keywordCity: '観念し',
    rememberCity: '観音寺',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0877',
    city: '丸亀',
    word: '丸亀バナナ',
    keywordNumber: 'バナナ',
    rememberNumber: '877',
    keywordCity: '丸亀',
    rememberCity: '丸亀',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※マジカルバナナのリズムで',
  },
  {
    length: '4',
    areacode: '0878',
    city: '高松',
    word: '納屋はあったかまつ',
    keywordNumber: '納屋',
    rememberNumber: '78',
    keywordCity: 'たかまつ',
    rememberCity: '高松',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0879',
    city: 'さぬき',
    word: '泣くほどうまい讃岐うどん',
    keywordNumber: '泣く',
    rememberNumber: '79',
    keywordCity: '讃岐うどん',
    rememberCity: '讃岐',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※讃岐うどん：讃岐の名産品',
  },
  {
    length: '3',
    areacode: '088',
    city: '徳島高知',
    word: '拍手をコーチに送っとく',
    keywordNumber: '拍手',
    rememberNumber: '88',
    keywordCity: 'コーチ、送っとく',
    rememberCity: '高知、徳島',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※88：拍手のネットスラング',
  },
  {
    length: '4',
    areacode: '0880',
    city: '四万十',
    word: '八万四万十',
    keywordNumber: '八万',
    rememberNumber: '80',
    keywordCity: '四万十',
    rememberCity: '四万十',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0883',
    city: '阿波',
    word: '婆さんの阿波踊り',
    keywordNumber: '婆さん',
    rememberNumber: '83',
    keywordCity: '阿波踊り',
    rememberCity: '阿波',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※阿波踊り：日本三大盆踊り',
  },
  {
    length: '4',
    areacode: '0884',
    city: '阿南',
    word: '端の抜け穴',
    keywordNumber: '端',
    rememberNumber: '84',
    keywordCity: '穴',
    rememberCity: '阿南',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0885',
    city: '小松島',
    word: '小松島',
    keywordNumber: '小',
    rememberNumber: '5',
    keywordCity: '小松島',
    rememberCity: '小松島',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0886',
    city: '徳島',
    word: 'ハム特売',
    keywordNumber: 'ハム',
    rememberNumber: '86',
    keywordCity: '特',
    rememberCity: '徳島',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0887',
    city: '安芸',
    word: '花飽きた',
    keywordNumber: '花',
    rememberNumber: '87',
    keywordCity: '飽きた',
    rememberCity: '安芸',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0888',
    city: '高知',
    word: '拍手をコーチに',
    keywordNumber: '拍手',
    rememberNumber: '888',
    keywordCity: 'コーチ',
    rememberCity: '高知',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0889',
    city: '須崎',
    word: 'はやくするさき',
    keywordNumber: 'はやく',
    rememberNumber: '889',
    keywordCity: 'するさき',
    rememberCity: '須崎',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '089',
    city: '愛媛',
    word: '野球拳は愛媛県',
    keywordNumber: '野球',
    rememberNumber: '89',
    keywordCity: '野球拳',
    rememberCity: '愛媛',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '※野球拳：松山が発祥地',
  },
  {
    length: '4',
    areacode: '0892',
    city: '久万高原',
    word: '発掘したの久しぶり',
    keywordNumber: '発掘',
    rememberNumber: '892',
    keywordCity: '久',
    rememberCity: '久万高原',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0893',
    city: '大洲',
    word: '白菜多すぎ',
    keywordNumber: '白菜',
    rememberNumber: '893',
    keywordCity: '多すぎ',
    rememberCity: '大洲市',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0894',
    city: '八幡浜',
    word: '白紙になった八万円',
    keywordNumber: '白紙',
    rememberNumber: '894',
    keywordCity: '八万',
    rememberCity: '八幡浜',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0895',
    city: '宇和島',
    word: '愚行だうわぁ',
    keywordNumber: '愚行',
    rememberNumber: '95',
    keywordCity: 'うわぁ',
    rememberCity: '宇和島',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0896',
    city: '四国中央',
    word: '四黒中央',
    keywordNumber: '黒',
    rememberNumber: '96',
    keywordCity: '四黒中央',
    rememberCity: '四国中央',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0897',
    city: '新居浜',
    word: '来んな新居に',
    keywordNumber: '来んな',
    rememberNumber: '97',
    keywordCity: '新居',
    rememberCity: '新居浜',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0898',
    city: '今治',
    word: '配っていたよ今治タオル',
    keywordNumber: '配',
    rememberNumber: '98',
    keywordCity: '今治タオル',
    rememberCity: '今治',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※今治タオル：今治の名産品',
  },
  {
    length: '4',
    areacode: '0899',
    city: '松山',
    word: '救急車を待つやま',
    keywordNumber: '救急',
    rememberNumber: '99',
    keywordCity: '待つやま',
    rememberCity: '松山',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '092',
    city: '福岡',
    word: '国を傾ける 博多美人',
    keywordNumber: '国',
    rememberNumber: '92',
    keywordCity: '博多美人',
    rememberCity: '福岡',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※傾国の美女 ※博多美人：日本三大美人',
  },
  {
    length: '4',
    areacode: '0920',
    city: '対馬',
    word: 'フレーフレー対抗馬！',
    keywordNumber: 'フレーフレー',
    rememberNumber: '20',
    keywordCity: '対抗馬',
    rememberCity: '対馬',
    dateAisu: '12/15',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '092x',
    city: '福岡',
    word: '子が中に 春の築城 いとださし',
    keywordNumber: '',
    rememberNumber: '',
    keywordCity: '子が、中、春、築、城、いと、ださし',
    rememberCity: '古河、那珂川、春日、筑紫野、大野城、糸島、大宰府',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '093',
    city: '北九州',
    word: 'キタクーサー',
    keywordNumber: 'クーサー',
    rememberNumber: '93',
    keywordCity: 'キタクーサー',
    rememberCity: '北九州',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0930',
    city: '行橋',
    word: '去れ！去ってゆくはし',
    keywordNumber: '去れ',
    rememberNumber: '30',
    keywordCity: 'ゆくはし',
    rememberCity: '行橋',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '093x',
    city: '北九州',
    word: 'キタクーサー',
    keywordNumber: 'クーサー',
    rememberNumber: '93',
    keywordCity: 'キタクーサー',
    rememberCity: '北九州',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '094',
    city: '久留米',
    word: '給仕はグルメ',
    keywordNumber: '給仕',
    rememberNumber: '94',
    keywordCity: 'グルメ',
    rememberCity: '久留米',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0940',
    city: '宗像',
    word: '指令は無かった',
    keywordNumber: '指令',
    rememberNumber: '40',
    keywordCity: '無かった',
    rememberCity: '宗像',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0942',
    city: '久留米',
    word: '質問が来るね',
    keywordNumber: '質',
    rememberNumber: '42',
    keywordCity: '来るね',
    rememberCity: '久留米',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0943',
    city: '八女',
    word: '嫁さん八女さん',
    keywordNumber: '嫁さん',
    rememberNumber: '43',
    keywordCity: '八女',
    rememberCity: '八女',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0944',
    city: '大牟田',
    word: 'シーシー！無駄口禁止！',
    keywordNumber: 'シーシー',
    rememberNumber: '44',
    keywordCity: '無駄',
    rememberCity: '大牟田',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0946',
    city: '朝倉',
    word: '白い朝',
    keywordNumber: '白',
    rememberNumber: '46',
    keywordCity: '朝',
    rememberCity: '朝倉',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0947',
    city: '田川',
    word: 'シナガワタガワ',
    keywordNumber: 'シナ',
    rememberNumber: '47',
    keywordCity: 'タガワ',
    rememberCity: '田川',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※シナムラ：0247 田村',
  },
  {
    length: '4',
    areacode: '0948',
    city: '飯塚',
    word: 'しあわせの飯図鑑',
    keywordNumber: 'しあわせ',
    rememberNumber: '48',
    keywordCity: '飯図鑑',
    rememberCity: '飯塚',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0949',
    city: '直方',
    word: '四角い直方体',
    keywordNumber: '四角',
    rememberNumber: '49',
    keywordCity: '直方',
    rememberCity: '直方',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '095',
    city: '佐賀長崎',
    word: 'さなぎに求婚',
    keywordNumber: '求婚',
    rememberNumber: '95',
    keywordCity: 'さ、なぎ',
    rememberCity: '佐賀、長崎',
    dateAisu: '',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0950',
    city: '平戸',
    word: 'ゴールは平屋一戸建て',
    keywordNumber: 'ゴー',
    rememberNumber: '50',
    keywordCity: '平屋一戸',
    rememberCity: '平戸',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0952',
    city: '佐賀',
    word: '鉱夫の性',
    keywordNumber: '鉱夫',
    rememberNumber: '52',
    keywordCity: '性',
    rememberCity: '佐賀',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0954',
    city: '武雄',
    word: 'ゴシゴシするだけお',
    keywordNumber: 'ゴシゴシ',
    rememberNumber: '54',
    keywordCity: 'だけお',
    rememberCity: '武雄',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0955',
    city: '伊万里',
    word: 'こまりいまり',
    keywordNumber: 'こ',
    rememberNumber: '5',
    keywordCity: '伊万里',
    rememberCity: '伊万里',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0956',
    city: '佐世保',
    word: 'ジャパネットたかたドットコム',
    keywordNumber: 'コム',
    rememberNumber: '56',
    keywordCity: 'ジャパネットたかた',
    rememberCity: '佐世保',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※ジャパネットたかた：佐世保市に本社がある通信販売会社',
  },
  {
    length: '4',
    areacode: '0957',
    city: '島原',
    word: '粉骨砕身 島原の乱',
    keywordNumber: '粉',
    rememberNumber: '57',
    keywordCity: '島原の乱',
    rememberCity: '島原',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※島原の乱：江戸時代の農民一揆',
  },
  {
    length: '4',
    areacode: '0958',
    city: '長崎',
    word: '今夜は長いよ',
    keywordNumber: '今夜',
    rememberNumber: '58',
    keywordCity: '長い',
    rememberCity: '長崎',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※0258長岡と同じ覚え方',
  },
  {
    length: '4',
    areacode: '0959',
    city: '西海',
    word: '国際会議',
    keywordNumber: '国',
    rememberNumber: '59',
    keywordCity: '際会',
    rememberCity: '西海',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '096',
    city: '熊本',
    word: 'まっくろくまモン 熊本県',
    keywordNumber: 'くろ',
    rememberNumber: '96',
    keywordCity: 'くまモン',
    rememberCity: '熊本',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '※くまモン：熊本市のマスコットキャラ',
  },
  {
    length: '4',
    areacode: '0962',
    city: '熊本',
    word: 'むつごろうvs熊',
    keywordNumber: 'むつ',
    rememberNumber: '62',
    keywordCity: '熊',
    rememberCity: '熊本',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※むつごろう：畑正憲(動物研究家)',
  },
  {
    length: '4',
    areacode: '0963',
    city: '熊本',
    word: '-',
    keywordNumber: '-',
    rememberNumber: '-',
    keywordCity: '-',
    rememberCity: '-',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0964',
    city: '宇土',
    word: '蒸しうどん',
    keywordNumber: '蒸し',
    rememberNumber: '64',
    keywordCity: 'うど',
    rememberCity: '宇土',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※宇土の読み方は正しくは「うど」ではなく「うと」',
  },
  {
    length: '4',
    areacode: '0965',
    city: '八代',
    word: '婿の八代目',
    keywordNumber: '婿',
    rememberNumber: '65',
    keywordCity: '八代',
    rememberCity: '八代',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0966',
    city: '水俣',
    word: 'クロム水',
    keywordNumber: 'クロム',
    rememberNumber: '966',
    keywordCity: '水',
    rememberCity: '水',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0967',
    city: '阿蘇',
    word: 'ムナーソ',
    keywordNumber: 'ムナ',
    rememberNumber: '67',
    keywordCity: 'ーソ',
    rememberCity: '阿蘇',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0968',
    city: '山鹿',
    word: 'クローバー食べるシカ',
    keywordNumber: 'クローバー',
    rememberNumber: '968',
    keywordCity: 'シカ',
    rememberCity: '山鹿',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0969',
    city: '天草',
    word: 'ロックの天才',
    keywordNumber: 'ロック',
    rememberNumber: '69',
    keywordCity: '天才',
    rememberCity: '天草',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '097',
    city: '大分',
    word: '苦難が多いた 大分県',
    keywordNumber: '苦難',
    rememberNumber: '97',
    keywordCity: '多いた',
    rememberCity: '大分',
    dateAisu: '10/21',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0972',
    city: '佐伯',
    word: '夏の祭典',
    keywordNumber: '夏',
    rememberNumber: '72',
    keywordCity: 'さい',
    rememberCity: '佐伯',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0973',
    city: '日田',
    word: '額の涙',
    keywordNumber: '涙',
    rememberNumber: '73',
    keywordCity: '額',
    rememberCity: '日田',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0974',
    city: '竹田',
    word: 'ナヨナヨな竹だ',
    keywordNumber: 'ナヨナヨ',
    rememberNumber: '74',
    keywordCity: '竹だ',
    rememberCity: '竹田',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0975',
    city: '大分',
    word: '苦難でござるよ 大友宗麟',
    keywordNumber: '苦難でご',
    rememberNumber: '975',
    keywordCity: '大友宗麟',
    rememberCity: '大分',
    dateAisu: '12/20',
    dateTorme: '',
    supplement: '※大友宗麟：大分の戦国武将',
  },
  {
    length: '4',
    areacode: '0977',
    city: '別府',
    word: '生は別腹',
    keywordNumber: '生',
    rememberNumber: '7',
    keywordCity: '別',
    rememberCity: '別府',
    dateAisu: '12/20',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0978',
    city: '豊後高田',
    word: '那覇はUSAだったかな',
    keywordNumber: '那覇',
    rememberNumber: '78',
    keywordCity: 'USA、たかな',
    rememberCity: '宇佐、豊後高田',
    dateAisu: '12/20',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0979',
    city: '中津',
    word: '泣く泣かす',
    keywordNumber: '泣く',
    rememberNumber: '79',
    keywordCity: '泣かす',
    rememberCity: '中津',
    dateAisu: '12/20',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '098',
    city: '宮崎那覇',
    word: '奥歯に大きなサキイカ',
    keywordNumber: '奥歯',
    rememberNumber: '098',
    keywordCity: '大きな、サキ',
    rememberCity: '沖縄、宮崎',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0980',
    city: '名護',
    word: 'バレバレな護衛',
    keywordNumber: 'バレバレ',
    rememberNumber: '80',
    keywordCity: 'な護',
    rememberCity: '名護',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0982',
    city: '延岡',
    word: 'パンツ伸びるよ',
    keywordNumber: 'パンツ',
    rememberNumber: '82',
    keywordCity: '伸',
    rememberCity: '延岡',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0983',
    city: '西都',
    word: '破砕とは',
    keywordNumber: '破砕',
    rememberNumber: '83',
    keywordCity: '砕と',
    rememberCity: '西都',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0984',
    city: '小林',
    word: '小林',
    keywordNumber: '林',
    rememberNumber: '84',
    keywordCity: '小林',
    rememberCity: '小林',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0985',
    city: '宮崎',
    word: '歯応えのある みやざき地頭鶏',
    keywordNumber: '歯ごたえ',
    rememberNumber: '85',
    keywordCity: 'みやざき地頭鶏',
    rememberCity: '宮崎',
    dateAisu: '12/20',
    dateTorme: '',
    supplement: '※みやざき地頭鶏：宮崎の名産品',
  },
  {
    length: '4',
    areacode: '0986',
    city: '都城',
    word: '配ろう都こんぶ',
    keywordNumber: '配ろう',
    rememberNumber: '986',
    keywordCity: '都',
    rememberCity: '都城',
    dateAisu: '12/20',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0987',
    city: '日南',
    word: 'バナナンにちなん',
    keywordNumber: 'バナナ',
    rememberNumber: '87',
    keywordCity: 'にちなん',
    rememberCity: '日南',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0988',
    city: '那覇',
    word: 'なははは',
    keywordNumber: 'はは',
    rememberNumber: '88',
    keywordCity: 'なは',
    rememberCity: '那覇',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0989',
    city: '那覇',
    word: '-',
    keywordNumber: '-',
    rememberNumber: '-',
    keywordCity: '-',
    rememberCity: '-',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '3',
    areacode: '099',
    city: '鹿児島',
    word: '99は隅っこ 鹿児島県',
    keywordNumber: '99',
    rememberNumber: '99',
    keywordCity: '隅っこ',
    rememberCity: '鹿児島県',
    dateAisu: '',
    dateTorme: '',
    supplement: '※大隅：鹿児島の旧国名',
  },
  {
    length: '4',
    areacode: '0991',
    city: '十島',
    word: 'クイズ十段',
    keywordNumber: 'クイズ',
    rememberNumber: '91',
    keywordCity: '十',
    rememberCity: '十島',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0992',
    city: '鹿児島',
    word: '靴の籠',
    keywordNumber: '靴',
    rememberNumber: '92',
    keywordCity: '籠',
    rememberCity: '鹿児島',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0993',
    city: '指宿',
    word: '草が息吹く',
    keywordNumber: '草',
    rememberNumber: '93',
    keywordCity: '息吹',
    rememberCity: '指宿',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0994',
    city: '志布志',
    word: '志布志',
    keywordNumber: '志',
    rememberNumber: '4',
    keywordCity: '志布志',
    rememberCity: '志布志',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0995',
    city: '霧島',
    word: '濃い霧',
    keywordNumber: '濃',
    rememberNumber: '5',
    keywordCity: '霧',
    rememberCity: '霧島',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
  {
    length: '4',
    areacode: '0996',
    city: '出水',
    word: '黒い水出た！',
    keywordNumber: '黒',
    rememberNumber: '96',
    keywordCity: 'い水出',
    rememberCity: '出水',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '※出水の読み方は「いずみ」',
  },
  {
    length: '4',
    areacode: '0997',
    city: '西之表',
    word: '苦難の種が表面化',
    keywordNumber: '苦難',
    rememberNumber: '97',
    keywordCity: '種が、表',
    rememberCity: '種子島、西之表',
    dateAisu: '12/16',
    dateTorme: '',
    supplement: '',
  },
]
